var Jt = Object.defineProperty, Yt = Object.defineProperties;
var jt = Object.getOwnPropertyDescriptors;
var Ke = Object.getOwnPropertySymbols;
var Xt = Object.prototype.hasOwnProperty, Zt = Object.prototype.propertyIsEnumerable;
var Qe = (g, m, b) => m in g ? Jt(g, m, { enumerable: !0, configurable: !0, writable: !0, value: b }) : g[m] = b, Je = (g, m) => {
  for (var b in m || (m = {}))
    Xt.call(m, b) && Qe(g, b, m[b]);
  if (Ke)
    for (var b of Ke(m))
      Zt.call(m, b) && Qe(g, b, m[b]);
  return g;
}, Ye = (g, m) => Yt(g, jt(m));
import { u as $t } from "./use-product-y102e61c.js";
import { u as er } from "./use-cart-D8NOb7eE.js";
import { m as j, c as w, e as O, u as je, a as te, o as tr, b as rr, f as U, l as re, w as K, i as Q, n as le, F as z, p as ne, g as M, t as B, k as N, h as J, a5 as Ie } from "./define-element-XpjsV6s1.js";
import { i as Y } from "./utils-CMsllPx8.js";
import { L as nr } from "./LoaderProduct-DFGIZnm0.js";
import { B as He } from "./Button-D5lKR5Sd.js";
import { P as ir } from "./Prop65Warning-CQH0AdaD.js";
import { Q as Te } from "./QuantitySelect-ZqpfOW1n.js";
import { g as sr } from "./_commonjsHelpers-C6fGbg64.js";
import { f as De } from "./format-currency-D_QngrXg.js";
import { _ as ar } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const or = [">=", "<=", "!=", ">", "<", "="];
function lr(g) {
  const m = g.trim();
  if (!m) return null;
  for (const b of or)
    if (m.startsWith(b)) {
      const y = m.slice(b.length).trim();
      return y ? { operator: b, value: y } : null;
    }
  return { operator: "=", value: m };
}
function ur(g) {
  if (!(g != null && g.trim())) return [];
  const m = [];
  for (const b of g.split(",")) {
    const y = b.indexOf(":");
    if (y === -1) continue;
    const k = b.slice(0, y).trim();
    if (!k) continue;
    const h = b.slice(y + 1).split("|").map(lr).filter((d) => d !== null);
    h.length !== 0 && m.push({ key: k, conditions: h });
  }
  return m;
}
function cr(g, m) {
  const { operator: b, value: y } = m;
  if (b === "=" || b === "!=") {
    const d = String(g != null ? g : "") === y;
    return b === "=" ? d : !d;
  }
  const k = Number(g), h = Number(y);
  return Number.isNaN(k) || Number.isNaN(h) ? !1 : b === ">" ? k > h : b === ">=" ? k >= h : b === "<" ? k < h : k <= h;
}
function hr(g, m) {
  return m.every((b) => b.conditions.some((y) => cr(g[b.key], y)));
}
function pr(g, m) {
  const b = ur(m);
  return b.length === 0 ? g : g.filter((y) => hr(y, b));
}
var ue = { exports: {} }, ce = { exports: {} }, F = {}, T = {}, Xe;
function D() {
  if (Xe) return T;
  Xe = 1, T.__esModule = !0, T.extend = k, T.indexOf = i, T.escapeExpression = a, T.isEmpty = n, T.createFrame = c, T.blockParams = r, T.appendContextPath = t;
  var g = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#x27;",
    "`": "&#x60;",
    "=": "&#x3D;"
  }, m = /[&<>"'`=]/g, b = /[&<>"'`=]/;
  function y(e) {
    return g[e];
  }
  function k(e) {
    for (var s = 1; s < arguments.length; s++)
      for (var o in arguments[s])
        Object.prototype.hasOwnProperty.call(arguments[s], o) && (e[o] = arguments[s][o]);
    return e;
  }
  var h = Object.prototype.toString;
  T.toString = h;
  var d = function(s) {
    return typeof s == "function";
  };
  d(/x/) && (T.isFunction = d = function(e) {
    return typeof e == "function" && h.call(e) === "[object Function]";
  }), T.isFunction = d;
  var u = Array.isArray || function(e) {
    return e && typeof e == "object" ? h.call(e) === "[object Array]" : !1;
  };
  T.isArray = u;
  function i(e, s) {
    for (var o = 0, f = e.length; o < f; o++)
      if (e[o] === s)
        return o;
    return -1;
  }
  function a(e) {
    if (typeof e != "string") {
      if (e && e.toHTML)
        return e.toHTML();
      if (e == null)
        return "";
      if (!e)
        return e + "";
      e = "" + e;
    }
    return b.test(e) ? e.replace(m, y) : e;
  }
  function n(e) {
    return !e && e !== 0 ? !0 : !!(u(e) && e.length === 0);
  }
  function c(e) {
    var s = k({}, e);
    return s._parent = e, s;
  }
  function r(e, s) {
    return e.path = s, e;
  }
  function t(e, s) {
    return (e ? e + "." : "") + s;
  }
  return T;
}
var he = { exports: {} }, Ze;
function G() {
  return Ze || (Ze = 1, (function(g, m) {
    m.__esModule = !0;
    var b = ["description", "fileName", "lineNumber", "endLineNumber", "message", "name", "number", "stack"];
    function y(k, h) {
      var d = h && h.loc, u = void 0, i = void 0, a = void 0, n = void 0;
      d && (u = d.start.line, i = d.end.line, a = d.start.column, n = d.end.column, k += " - " + u + ":" + a);
      for (var c = Error.prototype.constructor.call(this, k), r = 0; r < b.length; r++)
        this[b[r]] = c[b[r]];
      Error.captureStackTrace && Error.captureStackTrace(this, y);
      try {
        d && (this.lineNumber = u, this.endLineNumber = i, Object.defineProperty ? (Object.defineProperty(this, "column", {
          value: a,
          enumerable: !0
        }), Object.defineProperty(this, "endColumn", {
          value: n,
          enumerable: !0
        })) : (this.column = a, this.endColumn = n));
      } catch (t) {
      }
    }
    y.prototype = new Error(), m.default = y, g.exports = m.default;
  })(he, he.exports)), he.exports;
}
var ie = {}, pe = { exports: {} }, $e;
function fr() {
  return $e || ($e = 1, (function(g, m) {
    m.__esModule = !0;
    var b = D();
    m.default = function(y) {
      y.registerHelper("blockHelperMissing", function(k, h) {
        var d = h.inverse, u = h.fn;
        if (k === !0)
          return u(this);
        if (k === !1 || k == null)
          return d(this);
        if (b.isArray(k))
          return k.length > 0 ? (h.ids && (h.ids = [h.name]), y.helpers.each(k, h)) : d(this);
        if (h.data && h.ids) {
          var i = b.createFrame(h.data);
          i.contextPath = b.appendContextPath(h.data.contextPath, h.name), h = { data: i };
        }
        return u(k, h);
      });
    }, g.exports = m.default;
  })(pe, pe.exports)), pe.exports;
}
var fe = { exports: {} }, et;
function dr() {
  return et || (et = 1, (function(g, m) {
    m.__esModule = !0;
    function b(d) {
      return d && d.__esModule ? d : { default: d };
    }
    var y = D(), k = G(), h = b(k);
    m.default = function(d) {
      d.registerHelper("each", function(u, i) {
        if (!i)
          throw new h.default("Must pass iterator to #each");
        var a = i.fn, n = i.inverse, c = 0, r = "", t = void 0, e = void 0;
        i.data && i.ids && (e = y.appendContextPath(i.data.contextPath, i.ids[0]) + "."), y.isFunction(u) && (u = u.call(this)), i.data && (t = y.createFrame(i.data));
        function s(l, p, _) {
          t && (t.key = l, t.index = p, t.first = p === 0, t.last = !!_, e && (t.contextPath = e + l)), r = r + a(u[l], {
            data: t,
            blockParams: y.blockParams([u[l], l], [e + l, null])
          });
        }
        if (u && typeof u == "object")
          if (y.isArray(u))
            for (var o = u.length; c < o; c++)
              c in u && s(c, c, c === u.length - 1);
          else if (typeof Symbol == "function" && u[Symbol.iterator]) {
            for (var f = [], v = u[Symbol.iterator](), C = v.next(); !C.done; C = v.next())
              f.push(C.value);
            u = f;
            for (var o = u.length; c < o; c++)
              s(c, c, c === u.length - 1);
          } else
            (function() {
              var l = void 0;
              Object.keys(u).forEach(function(p) {
                l !== void 0 && s(l, c - 1), l = p, c++;
              }), l !== void 0 && s(l, c - 1, !0);
            })();
        return c === 0 && (r = n(this)), r;
      });
    }, g.exports = m.default;
  })(fe, fe.exports)), fe.exports;
}
var de = { exports: {} }, tt;
function vr() {
  return tt || (tt = 1, (function(g, m) {
    m.__esModule = !0;
    function b(h) {
      return h && h.__esModule ? h : { default: h };
    }
    var y = G(), k = b(y);
    m.default = function(h) {
      h.registerHelper("helperMissing", function() {
        if (arguments.length !== 1)
          throw new k.default('Missing helper: "' + arguments[arguments.length - 1].name + '"');
      });
    }, g.exports = m.default;
  })(de, de.exports)), de.exports;
}
var ve = { exports: {} }, rt;
function gr() {
  return rt || (rt = 1, (function(g, m) {
    m.__esModule = !0;
    function b(d) {
      return d && d.__esModule ? d : { default: d };
    }
    var y = D(), k = G(), h = b(k);
    m.default = function(d) {
      d.registerHelper("if", function(u, i) {
        if (arguments.length != 2)
          throw new h.default("#if requires exactly one argument");
        return y.isFunction(u) && (u = u.call(this)), !i.hash.includeZero && !u || y.isEmpty(u) ? i.inverse(this) : i.fn(this);
      }), d.registerHelper("unless", function(u, i) {
        if (arguments.length != 2)
          throw new h.default("#unless requires exactly one argument");
        return d.helpers.if.call(this, u, {
          fn: i.inverse,
          inverse: i.fn,
          hash: i.hash
        });
      });
    }, g.exports = m.default;
  })(ve, ve.exports)), ve.exports;
}
var ge = { exports: {} }, nt;
function mr() {
  return nt || (nt = 1, (function(g, m) {
    m.__esModule = !0, m.default = function(b) {
      b.registerHelper("log", function() {
        for (var y = [void 0], k = arguments[arguments.length - 1], h = 0; h < arguments.length - 1; h++)
          y.push(arguments[h]);
        var d = 1;
        k.hash.level != null ? d = k.hash.level : k.data && k.data.level != null && (d = k.data.level), y[0] = d, b.log.apply(b, y);
      });
    }, g.exports = m.default;
  })(ge, ge.exports)), ge.exports;
}
var me = { exports: {} }, it;
function _r() {
  return it || (it = 1, (function(g, m) {
    m.__esModule = !0, m.default = function(b) {
      b.registerHelper("lookup", function(y, k, h) {
        return y && h.lookupProperty(y, k);
      });
    }, g.exports = m.default;
  })(me, me.exports)), me.exports;
}
var _e = { exports: {} }, st;
function yr() {
  return st || (st = 1, (function(g, m) {
    m.__esModule = !0;
    function b(d) {
      return d && d.__esModule ? d : { default: d };
    }
    var y = D(), k = G(), h = b(k);
    m.default = function(d) {
      d.registerHelper("with", function(u, i) {
        if (arguments.length != 2)
          throw new h.default("#with requires exactly one argument");
        y.isFunction(u) && (u = u.call(this));
        var a = i.fn;
        if (y.isEmpty(u))
          return i.inverse(this);
        var n = i.data;
        return i.data && i.ids && (n = y.createFrame(i.data), n.contextPath = y.appendContextPath(i.data.contextPath, i.ids[0])), a(u, {
          data: n,
          blockParams: y.blockParams([u], [n && n.contextPath])
        });
      });
    }, g.exports = m.default;
  })(_e, _e.exports)), _e.exports;
}
var at;
function Bt() {
  if (at) return ie;
  at = 1, ie.__esModule = !0, ie.registerDefaultHelpers = s, ie.moveHelperToHooks = o;
  function g(f) {
    return f && f.__esModule ? f : { default: f };
  }
  var m = fr(), b = g(m), y = dr(), k = g(y), h = vr(), d = g(h), u = gr(), i = g(u), a = mr(), n = g(a), c = _r(), r = g(c), t = yr(), e = g(t);
  function s(f) {
    b.default(f), k.default(f), d.default(f), i.default(f), n.default(f), r.default(f), e.default(f);
  }
  function o(f, v, C) {
    f.helpers[v] && (f.hooks[v] = f.helpers[v], C || delete f.helpers[v]);
  }
  return ie;
}
var ye = {}, Se = { exports: {} }, ot;
function Sr() {
  return ot || (ot = 1, (function(g, m) {
    m.__esModule = !0;
    var b = D();
    m.default = function(y) {
      y.registerDecorator("inline", function(k, h, d, u) {
        var i = k;
        return h.partials || (h.partials = {}, i = function(a, n) {
          var c = d.partials;
          d.partials = b.extend({}, c, h.partials);
          var r = k(a, n);
          return d.partials = c, r;
        }), h.partials[u.args[0]] = u.fn, i;
      });
    }, g.exports = m.default;
  })(Se, Se.exports)), Se.exports;
}
var lt;
function kr() {
  if (lt) return ye;
  lt = 1, ye.__esModule = !0, ye.registerDefaultDecorators = y;
  function g(k) {
    return k && k.__esModule ? k : { default: k };
  }
  var m = Sr(), b = g(m);
  function y(k) {
    b.default(k);
  }
  return ye;
}
var ke = { exports: {} }, ut;
function Vt() {
  return ut || (ut = 1, (function(g, m) {
    m.__esModule = !0;
    var b = D(), y = {
      methodMap: ["debug", "info", "warn", "error"],
      level: "info",
      // Maps a given level value to the `methodMap` indexes above.
      lookupLevel: function(h) {
        if (typeof h == "string") {
          var d = b.indexOf(y.methodMap, h.toLowerCase());
          d >= 0 ? h = d : h = parseInt(h, 10);
        }
        return h;
      },
      // Can be overridden in the host environment
      log: function(h) {
        if (h = y.lookupLevel(h), typeof console != "undefined" && y.lookupLevel(y.level) <= h) {
          var d = y.methodMap[h];
          console[d] || (d = "log");
          for (var u = arguments.length, i = Array(u > 1 ? u - 1 : 0), a = 1; a < u; a++)
            i[a - 1] = arguments[a];
          console[d].apply(console, i);
        }
      }
    };
    m.default = y, g.exports = m.default;
  })(ke, ke.exports)), ke.exports;
}
var X = {}, be = {}, ct;
function br() {
  if (ct) return be;
  ct = 1, be.__esModule = !0, be.createNewLookupObject = m;
  var g = D();
  function m() {
    for (var b = arguments.length, y = Array(b), k = 0; k < b; k++)
      y[k] = arguments[k];
    return g.extend.apply(void 0, [/* @__PURE__ */ Object.create(null)].concat(y));
  }
  return be;
}
var ht;
function Ft() {
  if (ht) return X;
  ht = 1, X.__esModule = !0, X.createProtoAccessControl = h, X.resultIsAllowed = d, X.resetLoggedProperties = a;
  function g(n) {
    return n && n.__esModule ? n : { default: n };
  }
  var m = br(), b = Vt(), y = g(b), k = /* @__PURE__ */ Object.create(null);
  function h(n) {
    var c = /* @__PURE__ */ Object.create(null);
    c.constructor = !1, c.__defineGetter__ = !1, c.__defineSetter__ = !1, c.__lookupGetter__ = !1;
    var r = /* @__PURE__ */ Object.create(null);
    return r.__proto__ = !1, {
      properties: {
        whitelist: m.createNewLookupObject(r, n.allowedProtoProperties),
        defaultValue: n.allowProtoPropertiesByDefault
      },
      methods: {
        whitelist: m.createNewLookupObject(c, n.allowedProtoMethods),
        defaultValue: n.allowProtoMethodsByDefault
      }
    };
  }
  function d(n, c, r) {
    return u(typeof n == "function" ? c.methods : c.properties, r);
  }
  function u(n, c) {
    return n.whitelist[c] !== void 0 ? n.whitelist[c] === !0 : n.defaultValue !== void 0 ? n.defaultValue : (i(c), !1);
  }
  function i(n) {
    k[n] !== !0 && (k[n] = !0, y.default.log("error", 'Handlebars: Access has been denied to resolve the property "' + n + `" because it is not an "own property" of its parent.
You can add a runtime option to disable the check or this warning:
See https://handlebarsjs.com/api-reference/runtime-options.html#options-to-control-prototype-access for details`));
  }
  function a() {
    Object.keys(k).forEach(function(n) {
      delete k[n];
    });
  }
  return X;
}
var pt;
function ze() {
  if (pt) return F;
  pt = 1, F.__esModule = !0, F.HandlebarsEnvironment = e;
  function g(o) {
    return o && o.__esModule ? o : { default: o };
  }
  var m = D(), b = G(), y = g(b), k = Bt(), h = kr(), d = Vt(), u = g(d), i = Ft(), a = "4.7.8";
  F.VERSION = a;
  var n = 8;
  F.COMPILER_REVISION = n;
  var c = 7;
  F.LAST_COMPATIBLE_COMPILER_REVISION = c;
  var r = {
    1: "<= 1.0.rc.2",
    // 1.0.rc.2 is actually rev2 but doesn't report it
    2: "== 1.0.0-rc.3",
    3: "== 1.0.0-rc.4",
    4: "== 1.x.x",
    5: "== 2.0.0-alpha.x",
    6: ">= 2.0.0-beta.1",
    7: ">= 4.0.0 <4.3.0",
    8: ">= 4.3.0"
  };
  F.REVISION_CHANGES = r;
  var t = "[object Object]";
  function e(o, f, v) {
    this.helpers = o || {}, this.partials = f || {}, this.decorators = v || {}, k.registerDefaultHelpers(this), h.registerDefaultDecorators(this);
  }
  e.prototype = {
    constructor: e,
    logger: u.default,
    log: u.default.log,
    registerHelper: function(f, v) {
      if (m.toString.call(f) === t) {
        if (v)
          throw new y.default("Arg not supported with multiple helpers");
        m.extend(this.helpers, f);
      } else
        this.helpers[f] = v;
    },
    unregisterHelper: function(f) {
      delete this.helpers[f];
    },
    registerPartial: function(f, v) {
      if (m.toString.call(f) === t)
        m.extend(this.partials, f);
      else {
        if (typeof v == "undefined")
          throw new y.default('Attempting to register a partial called "' + f + '" as undefined');
        this.partials[f] = v;
      }
    },
    unregisterPartial: function(f) {
      delete this.partials[f];
    },
    registerDecorator: function(f, v) {
      if (m.toString.call(f) === t) {
        if (v)
          throw new y.default("Arg not supported with multiple decorators");
        m.extend(this.decorators, f);
      } else
        this.decorators[f] = v;
    },
    unregisterDecorator: function(f) {
      delete this.decorators[f];
    },
    /**
     * Reset the memory of illegal property accesses that have already been logged.
     * @deprecated should only be used in handlebars test-cases
     */
    resetLoggedPropertyAccesses: function() {
      i.resetLoggedProperties();
    }
  };
  var s = u.default.log;
  return F.log = s, F.createFrame = m.createFrame, F.logger = u.default, F;
}
var Ce = { exports: {} }, ft;
function Cr() {
  return ft || (ft = 1, (function(g, m) {
    m.__esModule = !0;
    function b(y) {
      this.string = y;
    }
    b.prototype.toString = b.prototype.toHTML = function() {
      return "" + this.string;
    }, m.default = b, g.exports = m.default;
  })(Ce, Ce.exports)), Ce.exports;
}
var W = {}, Le = {}, dt;
function Lr() {
  if (dt) return Le;
  dt = 1, Le.__esModule = !0, Le.wrapHelper = g;
  function g(m, b) {
    if (typeof m != "function")
      return m;
    var y = function() {
      var h = arguments[arguments.length - 1];
      return arguments[arguments.length - 1] = b(h), m.apply(this, arguments);
    };
    return y;
  }
  return Le;
}
var vt;
function Pr() {
  if (vt) return W;
  vt = 1, W.__esModule = !0, W.checkRevision = n, W.template = c, W.wrapProgram = r, W.resolvePartial = t, W.invokePartial = e, W.noop = s;
  function g(l) {
    return l && l.__esModule ? l : { default: l };
  }
  function m(l) {
    if (l && l.__esModule)
      return l;
    var p = {};
    if (l != null)
      for (var _ in l)
        Object.prototype.hasOwnProperty.call(l, _) && (p[_] = l[_]);
    return p.default = l, p;
  }
  var b = D(), y = m(b), k = G(), h = g(k), d = ze(), u = Bt(), i = Lr(), a = Ft();
  function n(l) {
    var p = l && l[0] || 1, _ = d.COMPILER_REVISION;
    if (!(p >= d.LAST_COMPATIBLE_COMPILER_REVISION && p <= d.COMPILER_REVISION))
      if (p < d.LAST_COMPATIBLE_COMPILER_REVISION) {
        var L = d.REVISION_CHANGES[_], E = d.REVISION_CHANGES[p];
        throw new h.default("Template was precompiled with an older version of Handlebars than the current runtime. Please update your precompiler to a newer version (" + L + ") or downgrade your runtime to an older version (" + E + ").");
      } else
        throw new h.default("Template was precompiled with a newer version of Handlebars than the current runtime. Please update your runtime to a newer version (" + l[1] + ").");
  }
  function c(l, p) {
    if (!p)
      throw new h.default("No environment passed to template");
    if (!l || !l.main)
      throw new h.default("Unknown template object: " + typeof l);
    l.main.decorator = l.main_d, p.VM.checkRevision(l.compiler);
    var _ = l.compiler && l.compiler[0] === 7;
    function L(x, S, P) {
      P.hash && (S = y.extend({}, S, P.hash), P.ids && (P.ids[0] = !0)), x = p.VM.resolvePartial.call(this, x, S, P);
      var R = y.extend({}, P, {
        hooks: this.hooks,
        protoAccessControl: this.protoAccessControl
      }), I = p.VM.invokePartial.call(this, x, S, R);
      if (I == null && p.compile && (P.partials[P.name] = p.compile(x, l.compilerOptions, p), I = P.partials[P.name](S, R)), I != null) {
        if (P.indent) {
          for (var H = I.split(`
`), q = 0, ee = H.length; q < ee && !(!H[q] && q + 1 === ee); q++)
            H[q] = P.indent + H[q];
          I = H.join(`
`);
        }
        return I;
      } else
        throw new h.default("The partial " + P.name + " could not be compiled when running in runtime-only mode");
    }
    var E = {
      strict: function(S, P, R) {
        if (!S || !(P in S))
          throw new h.default('"' + P + '" not defined in ' + S, {
            loc: R
          });
        return E.lookupProperty(S, P);
      },
      lookupProperty: function(S, P) {
        var R = S[P];
        if (R == null || Object.prototype.hasOwnProperty.call(S, P) || a.resultIsAllowed(R, E.protoAccessControl, P))
          return R;
      },
      lookup: function(S, P) {
        for (var R = S.length, I = 0; I < R; I++) {
          var H = S[I] && E.lookupProperty(S[I], P);
          if (H != null)
            return S[I][P];
        }
      },
      lambda: function(S, P) {
        return typeof S == "function" ? S.call(P) : S;
      },
      escapeExpression: y.escapeExpression,
      invokePartial: L,
      fn: function(S) {
        var P = l[S];
        return P.decorator = l[S + "_d"], P;
      },
      programs: [],
      program: function(S, P, R, I, H) {
        var q = this.programs[S], ee = this.fn(S);
        return P || H || I || R ? q = r(this, S, ee, P, R, I, H) : q || (q = this.programs[S] = r(this, S, ee)), q;
      },
      data: function(S, P) {
        for (; S && P--; )
          S = S._parent;
        return S;
      },
      mergeIfNeeded: function(S, P) {
        var R = S || P;
        return S && P && S !== P && (R = y.extend({}, P, S)), R;
      },
      // An empty object to use as replacement for null-contexts
      nullContext: Object.seal({}),
      noop: p.VM.noop,
      compilerInfo: l.compiler
    };
    function A(x) {
      var S = arguments.length <= 1 || arguments[1] === void 0 ? {} : arguments[1], P = S.data;
      A._setup(S), !S.partial && l.useData && (P = o(x, P));
      var R = void 0, I = l.useBlockParams ? [] : void 0;
      l.useDepths && (S.depths ? R = x != S.depths[0] ? [x].concat(S.depths) : S.depths : R = [x]);
      function H(q) {
        return "" + l.main(E, q, E.helpers, E.partials, P, I, R);
      }
      return H = f(l.main, H, E, S.depths || [], P, I), H(x, S);
    }
    return A.isTop = !0, A._setup = function(x) {
      if (x.partial)
        E.protoAccessControl = x.protoAccessControl, E.helpers = x.helpers, E.partials = x.partials, E.decorators = x.decorators, E.hooks = x.hooks;
      else {
        var S = y.extend({}, p.helpers, x.helpers);
        v(S, E), E.helpers = S, l.usePartial && (E.partials = E.mergeIfNeeded(x.partials, p.partials)), (l.usePartial || l.useDecorators) && (E.decorators = y.extend({}, p.decorators, x.decorators)), E.hooks = {}, E.protoAccessControl = a.createProtoAccessControl(x);
        var P = x.allowCallsToHelperMissing || _;
        u.moveHelperToHooks(E, "helperMissing", P), u.moveHelperToHooks(E, "blockHelperMissing", P);
      }
    }, A._child = function(x, S, P, R) {
      if (l.useBlockParams && !P)
        throw new h.default("must pass block params");
      if (l.useDepths && !R)
        throw new h.default("must pass parent depths");
      return r(E, x, l[x], S, 0, P, R);
    }, A;
  }
  function r(l, p, _, L, E, A, x) {
    function S(P) {
      var R = arguments.length <= 1 || arguments[1] === void 0 ? {} : arguments[1], I = x;
      return x && P != x[0] && !(P === l.nullContext && x[0] === null) && (I = [P].concat(x)), _(l, P, l.helpers, l.partials, R.data || L, A && [R.blockParams].concat(A), I);
    }
    return S = f(_, S, l, x, L, A), S.program = p, S.depth = x ? x.length : 0, S.blockParams = E || 0, S;
  }
  function t(l, p, _) {
    return l ? !l.call && !_.name && (_.name = l, l = _.partials[l]) : _.name === "@partial-block" ? l = _.data["partial-block"] : l = _.partials[_.name], l;
  }
  function e(l, p, _) {
    var L = _.data && _.data["partial-block"];
    _.partial = !0, _.ids && (_.data.contextPath = _.ids[0] || _.data.contextPath);
    var E = void 0;
    if (_.fn && _.fn !== s && (function() {
      _.data = d.createFrame(_.data);
      var A = _.fn;
      E = _.data["partial-block"] = function(S) {
        var P = arguments.length <= 1 || arguments[1] === void 0 ? {} : arguments[1];
        return P.data = d.createFrame(P.data), P.data["partial-block"] = L, A(S, P);
      }, A.partials && (_.partials = y.extend({}, _.partials, A.partials));
    })(), l === void 0 && E && (l = E), l === void 0)
      throw new h.default("The partial " + _.name + " could not be found");
    if (l instanceof Function)
      return l(p, _);
  }
  function s() {
    return "";
  }
  function o(l, p) {
    return (!p || !("root" in p)) && (p = p ? d.createFrame(p) : {}, p.root = l), p;
  }
  function f(l, p, _, L, E, A) {
    if (l.decorator) {
      var x = {};
      p = l.decorator(p, x, _, L && L[0], E, A, L), y.extend(p, x);
    }
    return p;
  }
  function v(l, p) {
    Object.keys(l).forEach(function(_) {
      var L = l[_];
      l[_] = C(L, p);
    });
  }
  function C(l, p) {
    var _ = p.lookupProperty;
    return i.wrapHelper(l, function(L) {
      return y.extend({ lookupProperty: _ }, L);
    });
  }
  return W;
}
var Pe = { exports: {} }, gt;
function Gt() {
  return gt || (gt = 1, (function(g, m) {
    m.__esModule = !0, m.default = function(b) {
      (function() {
        typeof globalThis != "object" && (Object.prototype.__defineGetter__("__magic__", function() {
          return this;
        }), __magic__.globalThis = __magic__, delete Object.prototype.__magic__);
      })();
      var y = globalThis.Handlebars;
      b.noConflict = function() {
        return globalThis.Handlebars === b && (globalThis.Handlebars = y), b;
      };
    }, g.exports = m.default;
  })(Pe, Pe.exports)), Pe.exports;
}
var mt;
function Mr() {
  return mt || (mt = 1, (function(g, m) {
    m.__esModule = !0;
    function b(v) {
      return v && v.__esModule ? v : { default: v };
    }
    function y(v) {
      if (v && v.__esModule)
        return v;
      var C = {};
      if (v != null)
        for (var l in v)
          Object.prototype.hasOwnProperty.call(v, l) && (C[l] = v[l]);
      return C.default = v, C;
    }
    var k = ze(), h = y(k), d = Cr(), u = b(d), i = G(), a = b(i), n = D(), c = y(n), r = Pr(), t = y(r), e = Gt(), s = b(e);
    function o() {
      var v = new h.HandlebarsEnvironment();
      return c.extend(v, h), v.SafeString = u.default, v.Exception = a.default, v.Utils = c, v.escapeExpression = c.escapeExpression, v.VM = t, v.template = function(C) {
        return t.template(C, v);
      }, v;
    }
    var f = o();
    f.create = o, s.default(f), f.default = f, m.default = f, g.exports = m.default;
  })(ce, ce.exports)), ce.exports;
}
var Me = { exports: {} }, _t;
function Ut() {
  return _t || (_t = 1, (function(g, m) {
    m.__esModule = !0;
    var b = {
      // Public API used to evaluate derived attributes regarding AST nodes
      helpers: {
        // a mustache is definitely a helper if:
        // * it is an eligible helper, and
        // * it has at least one parameter or hash segment
        helperExpression: function(k) {
          return k.type === "SubExpression" || (k.type === "MustacheStatement" || k.type === "BlockStatement") && !!(k.params && k.params.length || k.hash);
        },
        scopedId: function(k) {
          return /^\.|this\b/.test(k.original);
        },
        // an ID is simple if it only has one part, and that part is not
        // `..` or `this`.
        simpleId: function(k) {
          return k.parts.length === 1 && !b.helpers.scopedId(k) && !k.depth;
        }
      }
    };
    m.default = b, g.exports = m.default;
  })(Me, Me.exports)), Me.exports;
}
var Z = {}, Ee = { exports: {} }, yt;
function Er() {
  return yt || (yt = 1, (function(g, m) {
    m.__esModule = !0;
    var b = (function() {
      var y = {
        trace: function() {
        },
        yy: {},
        symbols_: { error: 2, root: 3, program: 4, EOF: 5, program_repetition0: 6, statement: 7, mustache: 8, block: 9, rawBlock: 10, partial: 11, partialBlock: 12, content: 13, COMMENT: 14, CONTENT: 15, openRawBlock: 16, rawBlock_repetition0: 17, END_RAW_BLOCK: 18, OPEN_RAW_BLOCK: 19, helperName: 20, openRawBlock_repetition0: 21, openRawBlock_option0: 22, CLOSE_RAW_BLOCK: 23, openBlock: 24, block_option0: 25, closeBlock: 26, openInverse: 27, block_option1: 28, OPEN_BLOCK: 29, openBlock_repetition0: 30, openBlock_option0: 31, openBlock_option1: 32, CLOSE: 33, OPEN_INVERSE: 34, openInverse_repetition0: 35, openInverse_option0: 36, openInverse_option1: 37, openInverseChain: 38, OPEN_INVERSE_CHAIN: 39, openInverseChain_repetition0: 40, openInverseChain_option0: 41, openInverseChain_option1: 42, inverseAndProgram: 43, INVERSE: 44, inverseChain: 45, inverseChain_option0: 46, OPEN_ENDBLOCK: 47, OPEN: 48, mustache_repetition0: 49, mustache_option0: 50, OPEN_UNESCAPED: 51, mustache_repetition1: 52, mustache_option1: 53, CLOSE_UNESCAPED: 54, OPEN_PARTIAL: 55, partialName: 56, partial_repetition0: 57, partial_option0: 58, openPartialBlock: 59, OPEN_PARTIAL_BLOCK: 60, openPartialBlock_repetition0: 61, openPartialBlock_option0: 62, param: 63, sexpr: 64, OPEN_SEXPR: 65, sexpr_repetition0: 66, sexpr_option0: 67, CLOSE_SEXPR: 68, hash: 69, hash_repetition_plus0: 70, hashSegment: 71, ID: 72, EQUALS: 73, blockParams: 74, OPEN_BLOCK_PARAMS: 75, blockParams_repetition_plus0: 76, CLOSE_BLOCK_PARAMS: 77, path: 78, dataName: 79, STRING: 80, NUMBER: 81, BOOLEAN: 82, UNDEFINED: 83, NULL: 84, DATA: 85, pathSegments: 86, SEP: 87, $accept: 0, $end: 1 },
        terminals_: { 2: "error", 5: "EOF", 14: "COMMENT", 15: "CONTENT", 18: "END_RAW_BLOCK", 19: "OPEN_RAW_BLOCK", 23: "CLOSE_RAW_BLOCK", 29: "OPEN_BLOCK", 33: "CLOSE", 34: "OPEN_INVERSE", 39: "OPEN_INVERSE_CHAIN", 44: "INVERSE", 47: "OPEN_ENDBLOCK", 48: "OPEN", 51: "OPEN_UNESCAPED", 54: "CLOSE_UNESCAPED", 55: "OPEN_PARTIAL", 60: "OPEN_PARTIAL_BLOCK", 65: "OPEN_SEXPR", 68: "CLOSE_SEXPR", 72: "ID", 73: "EQUALS", 75: "OPEN_BLOCK_PARAMS", 77: "CLOSE_BLOCK_PARAMS", 80: "STRING", 81: "NUMBER", 82: "BOOLEAN", 83: "UNDEFINED", 84: "NULL", 85: "DATA", 87: "SEP" },
        productions_: [0, [3, 2], [4, 1], [7, 1], [7, 1], [7, 1], [7, 1], [7, 1], [7, 1], [7, 1], [13, 1], [10, 3], [16, 5], [9, 4], [9, 4], [24, 6], [27, 6], [38, 6], [43, 2], [45, 3], [45, 1], [26, 3], [8, 5], [8, 5], [11, 5], [12, 3], [59, 5], [63, 1], [63, 1], [64, 5], [69, 1], [71, 3], [74, 3], [20, 1], [20, 1], [20, 1], [20, 1], [20, 1], [20, 1], [20, 1], [56, 1], [56, 1], [79, 2], [78, 1], [86, 3], [86, 1], [6, 0], [6, 2], [17, 0], [17, 2], [21, 0], [21, 2], [22, 0], [22, 1], [25, 0], [25, 1], [28, 0], [28, 1], [30, 0], [30, 2], [31, 0], [31, 1], [32, 0], [32, 1], [35, 0], [35, 2], [36, 0], [36, 1], [37, 0], [37, 1], [40, 0], [40, 2], [41, 0], [41, 1], [42, 0], [42, 1], [46, 0], [46, 1], [49, 0], [49, 2], [50, 0], [50, 1], [52, 0], [52, 2], [53, 0], [53, 1], [57, 0], [57, 2], [58, 0], [58, 1], [61, 0], [61, 2], [62, 0], [62, 1], [66, 0], [66, 2], [67, 0], [67, 1], [70, 1], [70, 2], [76, 1], [76, 2]],
        performAction: function(u, i, a, n, c, r, t) {
          var e = r.length - 1;
          switch (c) {
            case 1:
              return r[e - 1];
            case 2:
              this.$ = n.prepareProgram(r[e]);
              break;
            case 3:
              this.$ = r[e];
              break;
            case 4:
              this.$ = r[e];
              break;
            case 5:
              this.$ = r[e];
              break;
            case 6:
              this.$ = r[e];
              break;
            case 7:
              this.$ = r[e];
              break;
            case 8:
              this.$ = r[e];
              break;
            case 9:
              this.$ = {
                type: "CommentStatement",
                value: n.stripComment(r[e]),
                strip: n.stripFlags(r[e], r[e]),
                loc: n.locInfo(this._$)
              };
              break;
            case 10:
              this.$ = {
                type: "ContentStatement",
                original: r[e],
                value: r[e],
                loc: n.locInfo(this._$)
              };
              break;
            case 11:
              this.$ = n.prepareRawBlock(r[e - 2], r[e - 1], r[e], this._$);
              break;
            case 12:
              this.$ = { path: r[e - 3], params: r[e - 2], hash: r[e - 1] };
              break;
            case 13:
              this.$ = n.prepareBlock(r[e - 3], r[e - 2], r[e - 1], r[e], !1, this._$);
              break;
            case 14:
              this.$ = n.prepareBlock(r[e - 3], r[e - 2], r[e - 1], r[e], !0, this._$);
              break;
            case 15:
              this.$ = { open: r[e - 5], path: r[e - 4], params: r[e - 3], hash: r[e - 2], blockParams: r[e - 1], strip: n.stripFlags(r[e - 5], r[e]) };
              break;
            case 16:
              this.$ = { path: r[e - 4], params: r[e - 3], hash: r[e - 2], blockParams: r[e - 1], strip: n.stripFlags(r[e - 5], r[e]) };
              break;
            case 17:
              this.$ = { path: r[e - 4], params: r[e - 3], hash: r[e - 2], blockParams: r[e - 1], strip: n.stripFlags(r[e - 5], r[e]) };
              break;
            case 18:
              this.$ = { strip: n.stripFlags(r[e - 1], r[e - 1]), program: r[e] };
              break;
            case 19:
              var s = n.prepareBlock(r[e - 2], r[e - 1], r[e], r[e], !1, this._$), o = n.prepareProgram([s], r[e - 1].loc);
              o.chained = !0, this.$ = { strip: r[e - 2].strip, program: o, chain: !0 };
              break;
            case 20:
              this.$ = r[e];
              break;
            case 21:
              this.$ = { path: r[e - 1], strip: n.stripFlags(r[e - 2], r[e]) };
              break;
            case 22:
              this.$ = n.prepareMustache(r[e - 3], r[e - 2], r[e - 1], r[e - 4], n.stripFlags(r[e - 4], r[e]), this._$);
              break;
            case 23:
              this.$ = n.prepareMustache(r[e - 3], r[e - 2], r[e - 1], r[e - 4], n.stripFlags(r[e - 4], r[e]), this._$);
              break;
            case 24:
              this.$ = {
                type: "PartialStatement",
                name: r[e - 3],
                params: r[e - 2],
                hash: r[e - 1],
                indent: "",
                strip: n.stripFlags(r[e - 4], r[e]),
                loc: n.locInfo(this._$)
              };
              break;
            case 25:
              this.$ = n.preparePartialBlock(r[e - 2], r[e - 1], r[e], this._$);
              break;
            case 26:
              this.$ = { path: r[e - 3], params: r[e - 2], hash: r[e - 1], strip: n.stripFlags(r[e - 4], r[e]) };
              break;
            case 27:
              this.$ = r[e];
              break;
            case 28:
              this.$ = r[e];
              break;
            case 29:
              this.$ = {
                type: "SubExpression",
                path: r[e - 3],
                params: r[e - 2],
                hash: r[e - 1],
                loc: n.locInfo(this._$)
              };
              break;
            case 30:
              this.$ = { type: "Hash", pairs: r[e], loc: n.locInfo(this._$) };
              break;
            case 31:
              this.$ = { type: "HashPair", key: n.id(r[e - 2]), value: r[e], loc: n.locInfo(this._$) };
              break;
            case 32:
              this.$ = n.id(r[e - 1]);
              break;
            case 33:
              this.$ = r[e];
              break;
            case 34:
              this.$ = r[e];
              break;
            case 35:
              this.$ = { type: "StringLiteral", value: r[e], original: r[e], loc: n.locInfo(this._$) };
              break;
            case 36:
              this.$ = { type: "NumberLiteral", value: Number(r[e]), original: Number(r[e]), loc: n.locInfo(this._$) };
              break;
            case 37:
              this.$ = { type: "BooleanLiteral", value: r[e] === "true", original: r[e] === "true", loc: n.locInfo(this._$) };
              break;
            case 38:
              this.$ = { type: "UndefinedLiteral", original: void 0, value: void 0, loc: n.locInfo(this._$) };
              break;
            case 39:
              this.$ = { type: "NullLiteral", original: null, value: null, loc: n.locInfo(this._$) };
              break;
            case 40:
              this.$ = r[e];
              break;
            case 41:
              this.$ = r[e];
              break;
            case 42:
              this.$ = n.preparePath(!0, r[e], this._$);
              break;
            case 43:
              this.$ = n.preparePath(!1, r[e], this._$);
              break;
            case 44:
              r[e - 2].push({ part: n.id(r[e]), original: r[e], separator: r[e - 1] }), this.$ = r[e - 2];
              break;
            case 45:
              this.$ = [{ part: n.id(r[e]), original: r[e] }];
              break;
            case 46:
              this.$ = [];
              break;
            case 47:
              r[e - 1].push(r[e]);
              break;
            case 48:
              this.$ = [];
              break;
            case 49:
              r[e - 1].push(r[e]);
              break;
            case 50:
              this.$ = [];
              break;
            case 51:
              r[e - 1].push(r[e]);
              break;
            case 58:
              this.$ = [];
              break;
            case 59:
              r[e - 1].push(r[e]);
              break;
            case 64:
              this.$ = [];
              break;
            case 65:
              r[e - 1].push(r[e]);
              break;
            case 70:
              this.$ = [];
              break;
            case 71:
              r[e - 1].push(r[e]);
              break;
            case 78:
              this.$ = [];
              break;
            case 79:
              r[e - 1].push(r[e]);
              break;
            case 82:
              this.$ = [];
              break;
            case 83:
              r[e - 1].push(r[e]);
              break;
            case 86:
              this.$ = [];
              break;
            case 87:
              r[e - 1].push(r[e]);
              break;
            case 90:
              this.$ = [];
              break;
            case 91:
              r[e - 1].push(r[e]);
              break;
            case 94:
              this.$ = [];
              break;
            case 95:
              r[e - 1].push(r[e]);
              break;
            case 98:
              this.$ = [r[e]];
              break;
            case 99:
              r[e - 1].push(r[e]);
              break;
            case 100:
              this.$ = [r[e]];
              break;
            case 101:
              r[e - 1].push(r[e]);
              break;
          }
        },
        table: [{ 3: 1, 4: 2, 5: [2, 46], 6: 3, 14: [2, 46], 15: [2, 46], 19: [2, 46], 29: [2, 46], 34: [2, 46], 48: [2, 46], 51: [2, 46], 55: [2, 46], 60: [2, 46] }, { 1: [3] }, { 5: [1, 4] }, { 5: [2, 2], 7: 5, 8: 6, 9: 7, 10: 8, 11: 9, 12: 10, 13: 11, 14: [1, 12], 15: [1, 20], 16: 17, 19: [1, 23], 24: 15, 27: 16, 29: [1, 21], 34: [1, 22], 39: [2, 2], 44: [2, 2], 47: [2, 2], 48: [1, 13], 51: [1, 14], 55: [1, 18], 59: 19, 60: [1, 24] }, { 1: [2, 1] }, { 5: [2, 47], 14: [2, 47], 15: [2, 47], 19: [2, 47], 29: [2, 47], 34: [2, 47], 39: [2, 47], 44: [2, 47], 47: [2, 47], 48: [2, 47], 51: [2, 47], 55: [2, 47], 60: [2, 47] }, { 5: [2, 3], 14: [2, 3], 15: [2, 3], 19: [2, 3], 29: [2, 3], 34: [2, 3], 39: [2, 3], 44: [2, 3], 47: [2, 3], 48: [2, 3], 51: [2, 3], 55: [2, 3], 60: [2, 3] }, { 5: [2, 4], 14: [2, 4], 15: [2, 4], 19: [2, 4], 29: [2, 4], 34: [2, 4], 39: [2, 4], 44: [2, 4], 47: [2, 4], 48: [2, 4], 51: [2, 4], 55: [2, 4], 60: [2, 4] }, { 5: [2, 5], 14: [2, 5], 15: [2, 5], 19: [2, 5], 29: [2, 5], 34: [2, 5], 39: [2, 5], 44: [2, 5], 47: [2, 5], 48: [2, 5], 51: [2, 5], 55: [2, 5], 60: [2, 5] }, { 5: [2, 6], 14: [2, 6], 15: [2, 6], 19: [2, 6], 29: [2, 6], 34: [2, 6], 39: [2, 6], 44: [2, 6], 47: [2, 6], 48: [2, 6], 51: [2, 6], 55: [2, 6], 60: [2, 6] }, { 5: [2, 7], 14: [2, 7], 15: [2, 7], 19: [2, 7], 29: [2, 7], 34: [2, 7], 39: [2, 7], 44: [2, 7], 47: [2, 7], 48: [2, 7], 51: [2, 7], 55: [2, 7], 60: [2, 7] }, { 5: [2, 8], 14: [2, 8], 15: [2, 8], 19: [2, 8], 29: [2, 8], 34: [2, 8], 39: [2, 8], 44: [2, 8], 47: [2, 8], 48: [2, 8], 51: [2, 8], 55: [2, 8], 60: [2, 8] }, { 5: [2, 9], 14: [2, 9], 15: [2, 9], 19: [2, 9], 29: [2, 9], 34: [2, 9], 39: [2, 9], 44: [2, 9], 47: [2, 9], 48: [2, 9], 51: [2, 9], 55: [2, 9], 60: [2, 9] }, { 20: 25, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 36, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 4: 37, 6: 3, 14: [2, 46], 15: [2, 46], 19: [2, 46], 29: [2, 46], 34: [2, 46], 39: [2, 46], 44: [2, 46], 47: [2, 46], 48: [2, 46], 51: [2, 46], 55: [2, 46], 60: [2, 46] }, { 4: 38, 6: 3, 14: [2, 46], 15: [2, 46], 19: [2, 46], 29: [2, 46], 34: [2, 46], 44: [2, 46], 47: [2, 46], 48: [2, 46], 51: [2, 46], 55: [2, 46], 60: [2, 46] }, { 15: [2, 48], 17: 39, 18: [2, 48] }, { 20: 41, 56: 40, 64: 42, 65: [1, 43], 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 4: 44, 6: 3, 14: [2, 46], 15: [2, 46], 19: [2, 46], 29: [2, 46], 34: [2, 46], 47: [2, 46], 48: [2, 46], 51: [2, 46], 55: [2, 46], 60: [2, 46] }, { 5: [2, 10], 14: [2, 10], 15: [2, 10], 18: [2, 10], 19: [2, 10], 29: [2, 10], 34: [2, 10], 39: [2, 10], 44: [2, 10], 47: [2, 10], 48: [2, 10], 51: [2, 10], 55: [2, 10], 60: [2, 10] }, { 20: 45, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 46, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 47, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 41, 56: 48, 64: 42, 65: [1, 43], 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 33: [2, 78], 49: 49, 65: [2, 78], 72: [2, 78], 80: [2, 78], 81: [2, 78], 82: [2, 78], 83: [2, 78], 84: [2, 78], 85: [2, 78] }, { 23: [2, 33], 33: [2, 33], 54: [2, 33], 65: [2, 33], 68: [2, 33], 72: [2, 33], 75: [2, 33], 80: [2, 33], 81: [2, 33], 82: [2, 33], 83: [2, 33], 84: [2, 33], 85: [2, 33] }, { 23: [2, 34], 33: [2, 34], 54: [2, 34], 65: [2, 34], 68: [2, 34], 72: [2, 34], 75: [2, 34], 80: [2, 34], 81: [2, 34], 82: [2, 34], 83: [2, 34], 84: [2, 34], 85: [2, 34] }, { 23: [2, 35], 33: [2, 35], 54: [2, 35], 65: [2, 35], 68: [2, 35], 72: [2, 35], 75: [2, 35], 80: [2, 35], 81: [2, 35], 82: [2, 35], 83: [2, 35], 84: [2, 35], 85: [2, 35] }, { 23: [2, 36], 33: [2, 36], 54: [2, 36], 65: [2, 36], 68: [2, 36], 72: [2, 36], 75: [2, 36], 80: [2, 36], 81: [2, 36], 82: [2, 36], 83: [2, 36], 84: [2, 36], 85: [2, 36] }, { 23: [2, 37], 33: [2, 37], 54: [2, 37], 65: [2, 37], 68: [2, 37], 72: [2, 37], 75: [2, 37], 80: [2, 37], 81: [2, 37], 82: [2, 37], 83: [2, 37], 84: [2, 37], 85: [2, 37] }, { 23: [2, 38], 33: [2, 38], 54: [2, 38], 65: [2, 38], 68: [2, 38], 72: [2, 38], 75: [2, 38], 80: [2, 38], 81: [2, 38], 82: [2, 38], 83: [2, 38], 84: [2, 38], 85: [2, 38] }, { 23: [2, 39], 33: [2, 39], 54: [2, 39], 65: [2, 39], 68: [2, 39], 72: [2, 39], 75: [2, 39], 80: [2, 39], 81: [2, 39], 82: [2, 39], 83: [2, 39], 84: [2, 39], 85: [2, 39] }, { 23: [2, 43], 33: [2, 43], 54: [2, 43], 65: [2, 43], 68: [2, 43], 72: [2, 43], 75: [2, 43], 80: [2, 43], 81: [2, 43], 82: [2, 43], 83: [2, 43], 84: [2, 43], 85: [2, 43], 87: [1, 50] }, { 72: [1, 35], 86: 51 }, { 23: [2, 45], 33: [2, 45], 54: [2, 45], 65: [2, 45], 68: [2, 45], 72: [2, 45], 75: [2, 45], 80: [2, 45], 81: [2, 45], 82: [2, 45], 83: [2, 45], 84: [2, 45], 85: [2, 45], 87: [2, 45] }, { 52: 52, 54: [2, 82], 65: [2, 82], 72: [2, 82], 80: [2, 82], 81: [2, 82], 82: [2, 82], 83: [2, 82], 84: [2, 82], 85: [2, 82] }, { 25: 53, 38: 55, 39: [1, 57], 43: 56, 44: [1, 58], 45: 54, 47: [2, 54] }, { 28: 59, 43: 60, 44: [1, 58], 47: [2, 56] }, { 13: 62, 15: [1, 20], 18: [1, 61] }, { 33: [2, 86], 57: 63, 65: [2, 86], 72: [2, 86], 80: [2, 86], 81: [2, 86], 82: [2, 86], 83: [2, 86], 84: [2, 86], 85: [2, 86] }, { 33: [2, 40], 65: [2, 40], 72: [2, 40], 80: [2, 40], 81: [2, 40], 82: [2, 40], 83: [2, 40], 84: [2, 40], 85: [2, 40] }, { 33: [2, 41], 65: [2, 41], 72: [2, 41], 80: [2, 41], 81: [2, 41], 82: [2, 41], 83: [2, 41], 84: [2, 41], 85: [2, 41] }, { 20: 64, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 26: 65, 47: [1, 66] }, { 30: 67, 33: [2, 58], 65: [2, 58], 72: [2, 58], 75: [2, 58], 80: [2, 58], 81: [2, 58], 82: [2, 58], 83: [2, 58], 84: [2, 58], 85: [2, 58] }, { 33: [2, 64], 35: 68, 65: [2, 64], 72: [2, 64], 75: [2, 64], 80: [2, 64], 81: [2, 64], 82: [2, 64], 83: [2, 64], 84: [2, 64], 85: [2, 64] }, { 21: 69, 23: [2, 50], 65: [2, 50], 72: [2, 50], 80: [2, 50], 81: [2, 50], 82: [2, 50], 83: [2, 50], 84: [2, 50], 85: [2, 50] }, { 33: [2, 90], 61: 70, 65: [2, 90], 72: [2, 90], 80: [2, 90], 81: [2, 90], 82: [2, 90], 83: [2, 90], 84: [2, 90], 85: [2, 90] }, { 20: 74, 33: [2, 80], 50: 71, 63: 72, 64: 75, 65: [1, 43], 69: 73, 70: 76, 71: 77, 72: [1, 78], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 72: [1, 79] }, { 23: [2, 42], 33: [2, 42], 54: [2, 42], 65: [2, 42], 68: [2, 42], 72: [2, 42], 75: [2, 42], 80: [2, 42], 81: [2, 42], 82: [2, 42], 83: [2, 42], 84: [2, 42], 85: [2, 42], 87: [1, 50] }, { 20: 74, 53: 80, 54: [2, 84], 63: 81, 64: 75, 65: [1, 43], 69: 82, 70: 76, 71: 77, 72: [1, 78], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 26: 83, 47: [1, 66] }, { 47: [2, 55] }, { 4: 84, 6: 3, 14: [2, 46], 15: [2, 46], 19: [2, 46], 29: [2, 46], 34: [2, 46], 39: [2, 46], 44: [2, 46], 47: [2, 46], 48: [2, 46], 51: [2, 46], 55: [2, 46], 60: [2, 46] }, { 47: [2, 20] }, { 20: 85, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 4: 86, 6: 3, 14: [2, 46], 15: [2, 46], 19: [2, 46], 29: [2, 46], 34: [2, 46], 47: [2, 46], 48: [2, 46], 51: [2, 46], 55: [2, 46], 60: [2, 46] }, { 26: 87, 47: [1, 66] }, { 47: [2, 57] }, { 5: [2, 11], 14: [2, 11], 15: [2, 11], 19: [2, 11], 29: [2, 11], 34: [2, 11], 39: [2, 11], 44: [2, 11], 47: [2, 11], 48: [2, 11], 51: [2, 11], 55: [2, 11], 60: [2, 11] }, { 15: [2, 49], 18: [2, 49] }, { 20: 74, 33: [2, 88], 58: 88, 63: 89, 64: 75, 65: [1, 43], 69: 90, 70: 76, 71: 77, 72: [1, 78], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 65: [2, 94], 66: 91, 68: [2, 94], 72: [2, 94], 80: [2, 94], 81: [2, 94], 82: [2, 94], 83: [2, 94], 84: [2, 94], 85: [2, 94] }, { 5: [2, 25], 14: [2, 25], 15: [2, 25], 19: [2, 25], 29: [2, 25], 34: [2, 25], 39: [2, 25], 44: [2, 25], 47: [2, 25], 48: [2, 25], 51: [2, 25], 55: [2, 25], 60: [2, 25] }, { 20: 92, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 74, 31: 93, 33: [2, 60], 63: 94, 64: 75, 65: [1, 43], 69: 95, 70: 76, 71: 77, 72: [1, 78], 75: [2, 60], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 74, 33: [2, 66], 36: 96, 63: 97, 64: 75, 65: [1, 43], 69: 98, 70: 76, 71: 77, 72: [1, 78], 75: [2, 66], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 74, 22: 99, 23: [2, 52], 63: 100, 64: 75, 65: [1, 43], 69: 101, 70: 76, 71: 77, 72: [1, 78], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 74, 33: [2, 92], 62: 102, 63: 103, 64: 75, 65: [1, 43], 69: 104, 70: 76, 71: 77, 72: [1, 78], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 33: [1, 105] }, { 33: [2, 79], 65: [2, 79], 72: [2, 79], 80: [2, 79], 81: [2, 79], 82: [2, 79], 83: [2, 79], 84: [2, 79], 85: [2, 79] }, { 33: [2, 81] }, { 23: [2, 27], 33: [2, 27], 54: [2, 27], 65: [2, 27], 68: [2, 27], 72: [2, 27], 75: [2, 27], 80: [2, 27], 81: [2, 27], 82: [2, 27], 83: [2, 27], 84: [2, 27], 85: [2, 27] }, { 23: [2, 28], 33: [2, 28], 54: [2, 28], 65: [2, 28], 68: [2, 28], 72: [2, 28], 75: [2, 28], 80: [2, 28], 81: [2, 28], 82: [2, 28], 83: [2, 28], 84: [2, 28], 85: [2, 28] }, { 23: [2, 30], 33: [2, 30], 54: [2, 30], 68: [2, 30], 71: 106, 72: [1, 107], 75: [2, 30] }, { 23: [2, 98], 33: [2, 98], 54: [2, 98], 68: [2, 98], 72: [2, 98], 75: [2, 98] }, { 23: [2, 45], 33: [2, 45], 54: [2, 45], 65: [2, 45], 68: [2, 45], 72: [2, 45], 73: [1, 108], 75: [2, 45], 80: [2, 45], 81: [2, 45], 82: [2, 45], 83: [2, 45], 84: [2, 45], 85: [2, 45], 87: [2, 45] }, { 23: [2, 44], 33: [2, 44], 54: [2, 44], 65: [2, 44], 68: [2, 44], 72: [2, 44], 75: [2, 44], 80: [2, 44], 81: [2, 44], 82: [2, 44], 83: [2, 44], 84: [2, 44], 85: [2, 44], 87: [2, 44] }, { 54: [1, 109] }, { 54: [2, 83], 65: [2, 83], 72: [2, 83], 80: [2, 83], 81: [2, 83], 82: [2, 83], 83: [2, 83], 84: [2, 83], 85: [2, 83] }, { 54: [2, 85] }, { 5: [2, 13], 14: [2, 13], 15: [2, 13], 19: [2, 13], 29: [2, 13], 34: [2, 13], 39: [2, 13], 44: [2, 13], 47: [2, 13], 48: [2, 13], 51: [2, 13], 55: [2, 13], 60: [2, 13] }, { 38: 55, 39: [1, 57], 43: 56, 44: [1, 58], 45: 111, 46: 110, 47: [2, 76] }, { 33: [2, 70], 40: 112, 65: [2, 70], 72: [2, 70], 75: [2, 70], 80: [2, 70], 81: [2, 70], 82: [2, 70], 83: [2, 70], 84: [2, 70], 85: [2, 70] }, { 47: [2, 18] }, { 5: [2, 14], 14: [2, 14], 15: [2, 14], 19: [2, 14], 29: [2, 14], 34: [2, 14], 39: [2, 14], 44: [2, 14], 47: [2, 14], 48: [2, 14], 51: [2, 14], 55: [2, 14], 60: [2, 14] }, { 33: [1, 113] }, { 33: [2, 87], 65: [2, 87], 72: [2, 87], 80: [2, 87], 81: [2, 87], 82: [2, 87], 83: [2, 87], 84: [2, 87], 85: [2, 87] }, { 33: [2, 89] }, { 20: 74, 63: 115, 64: 75, 65: [1, 43], 67: 114, 68: [2, 96], 69: 116, 70: 76, 71: 77, 72: [1, 78], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 33: [1, 117] }, { 32: 118, 33: [2, 62], 74: 119, 75: [1, 120] }, { 33: [2, 59], 65: [2, 59], 72: [2, 59], 75: [2, 59], 80: [2, 59], 81: [2, 59], 82: [2, 59], 83: [2, 59], 84: [2, 59], 85: [2, 59] }, { 33: [2, 61], 75: [2, 61] }, { 33: [2, 68], 37: 121, 74: 122, 75: [1, 120] }, { 33: [2, 65], 65: [2, 65], 72: [2, 65], 75: [2, 65], 80: [2, 65], 81: [2, 65], 82: [2, 65], 83: [2, 65], 84: [2, 65], 85: [2, 65] }, { 33: [2, 67], 75: [2, 67] }, { 23: [1, 123] }, { 23: [2, 51], 65: [2, 51], 72: [2, 51], 80: [2, 51], 81: [2, 51], 82: [2, 51], 83: [2, 51], 84: [2, 51], 85: [2, 51] }, { 23: [2, 53] }, { 33: [1, 124] }, { 33: [2, 91], 65: [2, 91], 72: [2, 91], 80: [2, 91], 81: [2, 91], 82: [2, 91], 83: [2, 91], 84: [2, 91], 85: [2, 91] }, { 33: [2, 93] }, { 5: [2, 22], 14: [2, 22], 15: [2, 22], 19: [2, 22], 29: [2, 22], 34: [2, 22], 39: [2, 22], 44: [2, 22], 47: [2, 22], 48: [2, 22], 51: [2, 22], 55: [2, 22], 60: [2, 22] }, { 23: [2, 99], 33: [2, 99], 54: [2, 99], 68: [2, 99], 72: [2, 99], 75: [2, 99] }, { 73: [1, 108] }, { 20: 74, 63: 125, 64: 75, 65: [1, 43], 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 5: [2, 23], 14: [2, 23], 15: [2, 23], 19: [2, 23], 29: [2, 23], 34: [2, 23], 39: [2, 23], 44: [2, 23], 47: [2, 23], 48: [2, 23], 51: [2, 23], 55: [2, 23], 60: [2, 23] }, { 47: [2, 19] }, { 47: [2, 77] }, { 20: 74, 33: [2, 72], 41: 126, 63: 127, 64: 75, 65: [1, 43], 69: 128, 70: 76, 71: 77, 72: [1, 78], 75: [2, 72], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 5: [2, 24], 14: [2, 24], 15: [2, 24], 19: [2, 24], 29: [2, 24], 34: [2, 24], 39: [2, 24], 44: [2, 24], 47: [2, 24], 48: [2, 24], 51: [2, 24], 55: [2, 24], 60: [2, 24] }, { 68: [1, 129] }, { 65: [2, 95], 68: [2, 95], 72: [2, 95], 80: [2, 95], 81: [2, 95], 82: [2, 95], 83: [2, 95], 84: [2, 95], 85: [2, 95] }, { 68: [2, 97] }, { 5: [2, 21], 14: [2, 21], 15: [2, 21], 19: [2, 21], 29: [2, 21], 34: [2, 21], 39: [2, 21], 44: [2, 21], 47: [2, 21], 48: [2, 21], 51: [2, 21], 55: [2, 21], 60: [2, 21] }, { 33: [1, 130] }, { 33: [2, 63] }, { 72: [1, 132], 76: 131 }, { 33: [1, 133] }, { 33: [2, 69] }, { 15: [2, 12], 18: [2, 12] }, { 14: [2, 26], 15: [2, 26], 19: [2, 26], 29: [2, 26], 34: [2, 26], 47: [2, 26], 48: [2, 26], 51: [2, 26], 55: [2, 26], 60: [2, 26] }, { 23: [2, 31], 33: [2, 31], 54: [2, 31], 68: [2, 31], 72: [2, 31], 75: [2, 31] }, { 33: [2, 74], 42: 134, 74: 135, 75: [1, 120] }, { 33: [2, 71], 65: [2, 71], 72: [2, 71], 75: [2, 71], 80: [2, 71], 81: [2, 71], 82: [2, 71], 83: [2, 71], 84: [2, 71], 85: [2, 71] }, { 33: [2, 73], 75: [2, 73] }, { 23: [2, 29], 33: [2, 29], 54: [2, 29], 65: [2, 29], 68: [2, 29], 72: [2, 29], 75: [2, 29], 80: [2, 29], 81: [2, 29], 82: [2, 29], 83: [2, 29], 84: [2, 29], 85: [2, 29] }, { 14: [2, 15], 15: [2, 15], 19: [2, 15], 29: [2, 15], 34: [2, 15], 39: [2, 15], 44: [2, 15], 47: [2, 15], 48: [2, 15], 51: [2, 15], 55: [2, 15], 60: [2, 15] }, { 72: [1, 137], 77: [1, 136] }, { 72: [2, 100], 77: [2, 100] }, { 14: [2, 16], 15: [2, 16], 19: [2, 16], 29: [2, 16], 34: [2, 16], 44: [2, 16], 47: [2, 16], 48: [2, 16], 51: [2, 16], 55: [2, 16], 60: [2, 16] }, { 33: [1, 138] }, { 33: [2, 75] }, { 33: [2, 32] }, { 72: [2, 101], 77: [2, 101] }, { 14: [2, 17], 15: [2, 17], 19: [2, 17], 29: [2, 17], 34: [2, 17], 39: [2, 17], 44: [2, 17], 47: [2, 17], 48: [2, 17], 51: [2, 17], 55: [2, 17], 60: [2, 17] }],
        defaultActions: { 4: [2, 1], 54: [2, 55], 56: [2, 20], 60: [2, 57], 73: [2, 81], 82: [2, 85], 86: [2, 18], 90: [2, 89], 101: [2, 53], 104: [2, 93], 110: [2, 19], 111: [2, 77], 116: [2, 97], 119: [2, 63], 122: [2, 69], 135: [2, 75], 136: [2, 32] },
        parseError: function(u, i) {
          throw new Error(u);
        },
        parse: function(u) {
          var i = this, a = [0], n = [null], c = [], r = this.table, t = "", e = 0, s = 0;
          this.lexer.setInput(u), this.lexer.yy = this.yy, this.yy.lexer = this.lexer, this.yy.parser = this, typeof this.lexer.yylloc == "undefined" && (this.lexer.yylloc = {});
          var o = this.lexer.yylloc;
          c.push(o);
          var f = this.lexer.options && this.lexer.options.ranges;
          typeof this.yy.parseError == "function" && (this.parseError = this.yy.parseError);
          function v() {
            var R;
            return R = i.lexer.lex() || 1, typeof R != "number" && (R = i.symbols_[R] || R), R;
          }
          for (var C, l, p, _, L = {}, E, A, x, S; ; ) {
            if (l = a[a.length - 1], this.defaultActions[l] ? p = this.defaultActions[l] : ((C === null || typeof C == "undefined") && (C = v()), p = r[l] && r[l][C]), typeof p == "undefined" || !p.length || !p[0]) {
              var P = "";
              {
                S = [];
                for (E in r[l]) this.terminals_[E] && E > 2 && S.push("'" + this.terminals_[E] + "'");
                this.lexer.showPosition ? P = "Parse error on line " + (e + 1) + `:
` + this.lexer.showPosition() + `
Expecting ` + S.join(", ") + ", got '" + (this.terminals_[C] || C) + "'" : P = "Parse error on line " + (e + 1) + ": Unexpected " + (C == 1 ? "end of input" : "'" + (this.terminals_[C] || C) + "'"), this.parseError(P, { text: this.lexer.match, token: this.terminals_[C] || C, line: this.lexer.yylineno, loc: o, expected: S });
              }
            }
            if (p[0] instanceof Array && p.length > 1)
              throw new Error("Parse Error: multiple actions possible at state: " + l + ", token: " + C);
            switch (p[0]) {
              case 1:
                a.push(C), n.push(this.lexer.yytext), c.push(this.lexer.yylloc), a.push(p[1]), C = null, s = this.lexer.yyleng, t = this.lexer.yytext, e = this.lexer.yylineno, o = this.lexer.yylloc;
                break;
              case 2:
                if (A = this.productions_[p[1]][1], L.$ = n[n.length - A], L._$ = { first_line: c[c.length - (A || 1)].first_line, last_line: c[c.length - 1].last_line, first_column: c[c.length - (A || 1)].first_column, last_column: c[c.length - 1].last_column }, f && (L._$.range = [c[c.length - (A || 1)].range[0], c[c.length - 1].range[1]]), _ = this.performAction.call(L, t, s, e, this.yy, p[1], n, c), typeof _ != "undefined")
                  return _;
                A && (a = a.slice(0, -1 * A * 2), n = n.slice(0, -1 * A), c = c.slice(0, -1 * A)), a.push(this.productions_[p[1]][0]), n.push(L.$), c.push(L._$), x = r[a[a.length - 2]][a[a.length - 1]], a.push(x);
                break;
              case 3:
                return !0;
            }
          }
          return !0;
        }
      }, k = (function() {
        var d = {
          EOF: 1,
          parseError: function(i, a) {
            if (this.yy.parser)
              this.yy.parser.parseError(i, a);
            else
              throw new Error(i);
          },
          setInput: function(i) {
            return this._input = i, this._more = this._less = this.done = !1, this.yylineno = this.yyleng = 0, this.yytext = this.matched = this.match = "", this.conditionStack = ["INITIAL"], this.yylloc = { first_line: 1, first_column: 0, last_line: 1, last_column: 0 }, this.options.ranges && (this.yylloc.range = [0, 0]), this.offset = 0, this;
          },
          input: function() {
            var i = this._input[0];
            this.yytext += i, this.yyleng++, this.offset++, this.match += i, this.matched += i;
            var a = i.match(/(?:\r\n?|\n).*/g);
            return a ? (this.yylineno++, this.yylloc.last_line++) : this.yylloc.last_column++, this.options.ranges && this.yylloc.range[1]++, this._input = this._input.slice(1), i;
          },
          unput: function(i) {
            var a = i.length, n = i.split(/(?:\r\n?|\n)/g);
            this._input = i + this._input, this.yytext = this.yytext.substr(0, this.yytext.length - a - 1), this.offset -= a;
            var c = this.match.split(/(?:\r\n?|\n)/g);
            this.match = this.match.substr(0, this.match.length - 1), this.matched = this.matched.substr(0, this.matched.length - 1), n.length - 1 && (this.yylineno -= n.length - 1);
            var r = this.yylloc.range;
            return this.yylloc = {
              first_line: this.yylloc.first_line,
              last_line: this.yylineno + 1,
              first_column: this.yylloc.first_column,
              last_column: n ? (n.length === c.length ? this.yylloc.first_column : 0) + c[c.length - n.length].length - n[0].length : this.yylloc.first_column - a
            }, this.options.ranges && (this.yylloc.range = [r[0], r[0] + this.yyleng - a]), this;
          },
          more: function() {
            return this._more = !0, this;
          },
          less: function(i) {
            this.unput(this.match.slice(i));
          },
          pastInput: function() {
            var i = this.matched.substr(0, this.matched.length - this.match.length);
            return (i.length > 20 ? "..." : "") + i.substr(-20).replace(/\n/g, "");
          },
          upcomingInput: function() {
            var i = this.match;
            return i.length < 20 && (i += this._input.substr(0, 20 - i.length)), (i.substr(0, 20) + (i.length > 20 ? "..." : "")).replace(/\n/g, "");
          },
          showPosition: function() {
            var i = this.pastInput(), a = new Array(i.length + 1).join("-");
            return i + this.upcomingInput() + `
` + a + "^";
          },
          next: function() {
            if (this.done)
              return this.EOF;
            this._input || (this.done = !0);
            var i, a, n, c, r;
            this._more || (this.yytext = "", this.match = "");
            for (var t = this._currentRules(), e = 0; e < t.length && (n = this._input.match(this.rules[t[e]]), !(n && (!a || n[0].length > a[0].length) && (a = n, c = e, !this.options.flex))); e++)
              ;
            return a ? (r = a[0].match(/(?:\r\n?|\n).*/g), r && (this.yylineno += r.length), this.yylloc = {
              first_line: this.yylloc.last_line,
              last_line: this.yylineno + 1,
              first_column: this.yylloc.last_column,
              last_column: r ? r[r.length - 1].length - r[r.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + a[0].length
            }, this.yytext += a[0], this.match += a[0], this.matches = a, this.yyleng = this.yytext.length, this.options.ranges && (this.yylloc.range = [this.offset, this.offset += this.yyleng]), this._more = !1, this._input = this._input.slice(a[0].length), this.matched += a[0], i = this.performAction.call(this, this.yy, this, t[c], this.conditionStack[this.conditionStack.length - 1]), this.done && this._input && (this.done = !1), i || void 0) : this._input === "" ? this.EOF : this.parseError("Lexical error on line " + (this.yylineno + 1) + `. Unrecognized text.
` + this.showPosition(), { text: "", token: null, line: this.yylineno });
          },
          lex: function() {
            var i = this.next();
            return typeof i != "undefined" ? i : this.lex();
          },
          begin: function(i) {
            this.conditionStack.push(i);
          },
          popState: function() {
            return this.conditionStack.pop();
          },
          _currentRules: function() {
            return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
          },
          topState: function() {
            return this.conditionStack[this.conditionStack.length - 2];
          },
          pushState: function(i) {
            this.begin(i);
          }
        };
        return d.options = {}, d.performAction = function(i, a, n, c) {
          function r(t, e) {
            return a.yytext = a.yytext.substring(t, a.yyleng - e + t);
          }
          switch (n) {
            case 0:
              if (a.yytext.slice(-2) === "\\\\" ? (r(0, 1), this.begin("mu")) : a.yytext.slice(-1) === "\\" ? (r(0, 1), this.begin("emu")) : this.begin("mu"), a.yytext) return 15;
              break;
            case 1:
              return 15;
            case 2:
              return this.popState(), 15;
            case 3:
              return this.begin("raw"), 15;
            case 4:
              return this.popState(), this.conditionStack[this.conditionStack.length - 1] === "raw" ? 15 : (r(5, 9), "END_RAW_BLOCK");
            case 5:
              return 15;
            case 6:
              return this.popState(), 14;
            case 7:
              return 65;
            case 8:
              return 68;
            case 9:
              return 19;
            case 10:
              return this.popState(), this.begin("raw"), 23;
            case 11:
              return 55;
            case 12:
              return 60;
            case 13:
              return 29;
            case 14:
              return 47;
            case 15:
              return this.popState(), 44;
            case 16:
              return this.popState(), 44;
            case 17:
              return 34;
            case 18:
              return 39;
            case 19:
              return 51;
            case 20:
              return 48;
            case 21:
              this.unput(a.yytext), this.popState(), this.begin("com");
              break;
            case 22:
              return this.popState(), 14;
            case 23:
              return 48;
            case 24:
              return 73;
            case 25:
              return 72;
            case 26:
              return 72;
            case 27:
              return 87;
            case 28:
              break;
            case 29:
              return this.popState(), 54;
            case 30:
              return this.popState(), 33;
            case 31:
              return a.yytext = r(1, 2).replace(/\\"/g, '"'), 80;
            case 32:
              return a.yytext = r(1, 2).replace(/\\'/g, "'"), 80;
            case 33:
              return 85;
            case 34:
              return 82;
            case 35:
              return 82;
            case 36:
              return 83;
            case 37:
              return 84;
            case 38:
              return 81;
            case 39:
              return 75;
            case 40:
              return 77;
            case 41:
              return 72;
            case 42:
              return a.yytext = a.yytext.replace(/\\([\\\]])/g, "$1"), 72;
            case 43:
              return "INVALID";
            case 44:
              return 5;
          }
        }, d.rules = [/^(?:[^\x00]*?(?=(\{\{)))/, /^(?:[^\x00]+)/, /^(?:[^\x00]{2,}?(?=(\{\{|\\\{\{|\\\\\{\{|$)))/, /^(?:\{\{\{\{(?=[^/]))/, /^(?:\{\{\{\{\/[^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=[=}\s\/.])\}\}\}\})/, /^(?:[^\x00]+?(?=(\{\{\{\{)))/, /^(?:[\s\S]*?--(~)?\}\})/, /^(?:\()/, /^(?:\))/, /^(?:\{\{\{\{)/, /^(?:\}\}\}\})/, /^(?:\{\{(~)?>)/, /^(?:\{\{(~)?#>)/, /^(?:\{\{(~)?#\*?)/, /^(?:\{\{(~)?\/)/, /^(?:\{\{(~)?\^\s*(~)?\}\})/, /^(?:\{\{(~)?\s*else\s*(~)?\}\})/, /^(?:\{\{(~)?\^)/, /^(?:\{\{(~)?\s*else\b)/, /^(?:\{\{(~)?\{)/, /^(?:\{\{(~)?&)/, /^(?:\{\{(~)?!--)/, /^(?:\{\{(~)?![\s\S]*?\}\})/, /^(?:\{\{(~)?\*?)/, /^(?:=)/, /^(?:\.\.)/, /^(?:\.(?=([=~}\s\/.)|])))/, /^(?:[\/.])/, /^(?:\s+)/, /^(?:\}(~)?\}\})/, /^(?:(~)?\}\})/, /^(?:"(\\["]|[^"])*")/, /^(?:'(\\[']|[^'])*')/, /^(?:@)/, /^(?:true(?=([~}\s)])))/, /^(?:false(?=([~}\s)])))/, /^(?:undefined(?=([~}\s)])))/, /^(?:null(?=([~}\s)])))/, /^(?:-?[0-9]+(?:\.[0-9]+)?(?=([~}\s)])))/, /^(?:as\s+\|)/, /^(?:\|)/, /^(?:([^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=([=~}\s\/.)|]))))/, /^(?:\[(\\\]|[^\]])*\])/, /^(?:.)/, /^(?:$)/], d.conditions = { mu: { rules: [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44], inclusive: !1 }, emu: { rules: [2], inclusive: !1 }, com: { rules: [6], inclusive: !1 }, raw: { rules: [3, 4, 5], inclusive: !1 }, INITIAL: { rules: [0, 1, 44], inclusive: !0 } }, d;
      })();
      y.lexer = k;
      function h() {
        this.yy = {};
      }
      return h.prototype = y, y.Parser = h, new h();
    })();
    m.default = b, g.exports = m.default;
  })(Ee, Ee.exports)), Ee.exports;
}
var xe = { exports: {} }, we = { exports: {} }, St;
function Wt() {
  return St || (St = 1, (function(g, m) {
    m.__esModule = !0;
    function b(a) {
      return a && a.__esModule ? a : { default: a };
    }
    var y = G(), k = b(y);
    function h() {
      this.parents = [];
    }
    h.prototype = {
      constructor: h,
      mutating: !1,
      // Visits a given value. If mutating, will replace the value if necessary.
      acceptKey: function(n, c) {
        var r = this.accept(n[c]);
        if (this.mutating) {
          if (r && !h.prototype[r.type])
            throw new k.default('Unexpected node type "' + r.type + '" found when accepting ' + c + " on " + n.type);
          n[c] = r;
        }
      },
      // Performs an accept operation with added sanity check to ensure
      // required keys are not removed.
      acceptRequired: function(n, c) {
        if (this.acceptKey(n, c), !n[c])
          throw new k.default(n.type + " requires " + c);
      },
      // Traverses a given array. If mutating, empty respnses will be removed
      // for child elements.
      acceptArray: function(n) {
        for (var c = 0, r = n.length; c < r; c++)
          this.acceptKey(n, c), n[c] || (n.splice(c, 1), c--, r--);
      },
      accept: function(n) {
        if (n) {
          if (!this[n.type])
            throw new k.default("Unknown type: " + n.type, n);
          this.current && this.parents.unshift(this.current), this.current = n;
          var c = this[n.type](n);
          if (this.current = this.parents.shift(), !this.mutating || c)
            return c;
          if (c !== !1)
            return n;
        }
      },
      Program: function(n) {
        this.acceptArray(n.body);
      },
      MustacheStatement: d,
      Decorator: d,
      BlockStatement: u,
      DecoratorBlock: u,
      PartialStatement: i,
      PartialBlockStatement: function(n) {
        i.call(this, n), this.acceptKey(n, "program");
      },
      ContentStatement: function() {
      },
      CommentStatement: function() {
      },
      SubExpression: d,
      PathExpression: function() {
      },
      StringLiteral: function() {
      },
      NumberLiteral: function() {
      },
      BooleanLiteral: function() {
      },
      UndefinedLiteral: function() {
      },
      NullLiteral: function() {
      },
      Hash: function(n) {
        this.acceptArray(n.pairs);
      },
      HashPair: function(n) {
        this.acceptRequired(n, "value");
      }
    };
    function d(a) {
      this.acceptRequired(a, "path"), this.acceptArray(a.params), this.acceptKey(a, "hash");
    }
    function u(a) {
      d.call(this, a), this.acceptKey(a, "program"), this.acceptKey(a, "inverse");
    }
    function i(a) {
      this.acceptRequired(a, "name"), this.acceptArray(a.params), this.acceptKey(a, "hash");
    }
    m.default = h, g.exports = m.default;
  })(we, we.exports)), we.exports;
}
var kt;
function xr() {
  return kt || (kt = 1, (function(g, m) {
    m.__esModule = !0;
    function b(n) {
      return n && n.__esModule ? n : { default: n };
    }
    var y = Wt(), k = b(y);
    function h() {
      var n = arguments.length <= 0 || arguments[0] === void 0 ? {} : arguments[0];
      this.options = n;
    }
    h.prototype = new k.default(), h.prototype.Program = function(n) {
      var c = !this.options.ignoreStandalone, r = !this.isRootSeen;
      this.isRootSeen = !0;
      for (var t = n.body, e = 0, s = t.length; e < s; e++) {
        var o = t[e], f = this.accept(o);
        if (f) {
          var v = d(t, e, r), C = u(t, e, r), l = f.openStandalone && v, p = f.closeStandalone && C, _ = f.inlineStandalone && v && C;
          f.close && i(t, e, !0), f.open && a(t, e, !0), c && _ && (i(t, e), a(t, e) && o.type === "PartialStatement" && (o.indent = /([ \t]+$)/.exec(t[e - 1].original)[1])), c && l && (i((o.program || o.inverse).body), a(t, e)), c && p && (i(t, e), a((o.inverse || o.program).body));
        }
      }
      return n;
    }, h.prototype.BlockStatement = h.prototype.DecoratorBlock = h.prototype.PartialBlockStatement = function(n) {
      this.accept(n.program), this.accept(n.inverse);
      var c = n.program || n.inverse, r = n.program && n.inverse, t = r, e = r;
      if (r && r.chained)
        for (t = r.body[0].program; e.chained; )
          e = e.body[e.body.length - 1].program;
      var s = {
        open: n.openStrip.open,
        close: n.closeStrip.close,
        // Determine the standalone candiacy. Basically flag our content as being possibly standalone
        // so our parent can determine if we actually are standalone
        openStandalone: u(c.body),
        closeStandalone: d((t || c).body)
      };
      if (n.openStrip.close && i(c.body, null, !0), r) {
        var o = n.inverseStrip;
        o.open && a(c.body, null, !0), o.close && i(t.body, null, !0), n.closeStrip.open && a(e.body, null, !0), !this.options.ignoreStandalone && d(c.body) && u(t.body) && (a(c.body), i(t.body));
      } else n.closeStrip.open && a(c.body, null, !0);
      return s;
    }, h.prototype.Decorator = h.prototype.MustacheStatement = function(n) {
      return n.strip;
    }, h.prototype.PartialStatement = h.prototype.CommentStatement = function(n) {
      var c = n.strip || {};
      return {
        inlineStandalone: !0,
        open: c.open,
        close: c.close
      };
    };
    function d(n, c, r) {
      c === void 0 && (c = n.length);
      var t = n[c - 1], e = n[c - 2];
      if (!t)
        return r;
      if (t.type === "ContentStatement")
        return (e || !r ? /\r?\n\s*?$/ : /(^|\r?\n)\s*?$/).test(t.original);
    }
    function u(n, c, r) {
      c === void 0 && (c = -1);
      var t = n[c + 1], e = n[c + 2];
      if (!t)
        return r;
      if (t.type === "ContentStatement")
        return (e || !r ? /^\s*?\r?\n/ : /^\s*?(\r?\n|$)/).test(t.original);
    }
    function i(n, c, r) {
      var t = n[c == null ? 0 : c + 1];
      if (!(!t || t.type !== "ContentStatement" || !r && t.rightStripped)) {
        var e = t.value;
        t.value = t.value.replace(r ? /^\s+/ : /^[ \t]*\r?\n?/, ""), t.rightStripped = t.value !== e;
      }
    }
    function a(n, c, r) {
      var t = n[c == null ? n.length - 1 : c - 1];
      if (!(!t || t.type !== "ContentStatement" || !r && t.leftStripped)) {
        var e = t.value;
        return t.value = t.value.replace(r ? /\s+$/ : /[ \t]+$/, ""), t.leftStripped = t.value !== e, t.leftStripped;
      }
    }
    m.default = h, g.exports = m.default;
  })(xe, xe.exports)), xe.exports;
}
var V = {}, bt;
function wr() {
  if (bt) return V;
  bt = 1, V.__esModule = !0, V.SourceLocation = k, V.id = h, V.stripFlags = d, V.stripComment = u, V.preparePath = i, V.prepareMustache = a, V.prepareRawBlock = n, V.prepareBlock = c, V.prepareProgram = r, V.preparePartialBlock = t;
  function g(e) {
    return e && e.__esModule ? e : { default: e };
  }
  var m = G(), b = g(m);
  function y(e, s) {
    if (s = s.path ? s.path.original : s, e.path.original !== s) {
      var o = { loc: e.path.loc };
      throw new b.default(e.path.original + " doesn't match " + s, o);
    }
  }
  function k(e, s) {
    this.source = e, this.start = {
      line: s.first_line,
      column: s.first_column
    }, this.end = {
      line: s.last_line,
      column: s.last_column
    };
  }
  function h(e) {
    return /^\[.*\]$/.test(e) ? e.substring(1, e.length - 1) : e;
  }
  function d(e, s) {
    return {
      open: e.charAt(2) === "~",
      close: s.charAt(s.length - 3) === "~"
    };
  }
  function u(e) {
    return e.replace(/^\{\{~?!-?-?/, "").replace(/-?-?~?\}\}$/, "");
  }
  function i(e, s, o) {
    o = this.locInfo(o);
    for (var f = e ? "@" : "", v = [], C = 0, l = 0, p = s.length; l < p; l++) {
      var _ = s[l].part, L = s[l].original !== _;
      if (f += (s[l].separator || "") + _, !L && (_ === ".." || _ === "." || _ === "this")) {
        if (v.length > 0)
          throw new b.default("Invalid path: " + f, { loc: o });
        _ === ".." && C++;
      } else
        v.push(_);
    }
    return {
      type: "PathExpression",
      data: e,
      depth: C,
      parts: v,
      original: f,
      loc: o
    };
  }
  function a(e, s, o, f, v, C) {
    var l = f.charAt(3) || f.charAt(2), p = l !== "{" && l !== "&", _ = /\*/.test(f);
    return {
      type: _ ? "Decorator" : "MustacheStatement",
      path: e,
      params: s,
      hash: o,
      escaped: p,
      strip: v,
      loc: this.locInfo(C)
    };
  }
  function n(e, s, o, f) {
    y(e, o), f = this.locInfo(f);
    var v = {
      type: "Program",
      body: s,
      strip: {},
      loc: f
    };
    return {
      type: "BlockStatement",
      path: e.path,
      params: e.params,
      hash: e.hash,
      program: v,
      openStrip: {},
      inverseStrip: {},
      closeStrip: {},
      loc: f
    };
  }
  function c(e, s, o, f, v, C) {
    f && f.path && y(e, f);
    var l = /\*/.test(e.open);
    s.blockParams = e.blockParams;
    var p = void 0, _ = void 0;
    if (o) {
      if (l)
        throw new b.default("Unexpected inverse block on decorator", o);
      o.chain && (o.program.body[0].closeStrip = f.strip), _ = o.strip, p = o.program;
    }
    return v && (v = p, p = s, s = v), {
      type: l ? "DecoratorBlock" : "BlockStatement",
      path: e.path,
      params: e.params,
      hash: e.hash,
      program: s,
      inverse: p,
      openStrip: e.strip,
      inverseStrip: _,
      closeStrip: f && f.strip,
      loc: this.locInfo(C)
    };
  }
  function r(e, s) {
    if (!s && e.length) {
      var o = e[0].loc, f = e[e.length - 1].loc;
      o && f && (s = {
        source: o.source,
        start: {
          line: o.start.line,
          column: o.start.column
        },
        end: {
          line: f.end.line,
          column: f.end.column
        }
      });
    }
    return {
      type: "Program",
      body: e,
      strip: {},
      loc: s
    };
  }
  function t(e, s, o, f) {
    return y(e, o), {
      type: "PartialBlockStatement",
      name: e.path,
      params: e.params,
      hash: e.hash,
      program: s,
      openStrip: e.strip,
      closeStrip: o && o.strip,
      loc: this.locInfo(f)
    };
  }
  return V;
}
var Ct;
function Or() {
  if (Ct) return Z;
  Ct = 1, Z.__esModule = !0, Z.parseWithoutProcessing = n, Z.parse = c;
  function g(r) {
    if (r && r.__esModule)
      return r;
    var t = {};
    if (r != null)
      for (var e in r)
        Object.prototype.hasOwnProperty.call(r, e) && (t[e] = r[e]);
    return t.default = r, t;
  }
  function m(r) {
    return r && r.__esModule ? r : { default: r };
  }
  var b = Er(), y = m(b), k = xr(), h = m(k), d = wr(), u = g(d), i = D();
  Z.parser = y.default;
  var a = {};
  i.extend(a, u);
  function n(r, t) {
    if (r.type === "Program")
      return r;
    y.default.yy = a, a.locInfo = function(s) {
      return new a.SourceLocation(t && t.srcName, s);
    };
    var e = y.default.parse(r);
    return e;
  }
  function c(r, t) {
    var e = n(r, t), s = new h.default(t);
    return s.accept(e);
  }
  return Z;
}
var $ = {}, Lt;
function Ar() {
  if (Lt) return $;
  Lt = 1, $.__esModule = !0, $.Compiler = u, $.precompile = i, $.compile = a;
  function g(r) {
    return r && r.__esModule ? r : { default: r };
  }
  var m = G(), b = g(m), y = D(), k = Ut(), h = g(k), d = [].slice;
  function u() {
  }
  u.prototype = {
    compiler: u,
    equals: function(t) {
      var e = this.opcodes.length;
      if (t.opcodes.length !== e)
        return !1;
      for (var s = 0; s < e; s++) {
        var o = this.opcodes[s], f = t.opcodes[s];
        if (o.opcode !== f.opcode || !n(o.args, f.args))
          return !1;
      }
      e = this.children.length;
      for (var s = 0; s < e; s++)
        if (!this.children[s].equals(t.children[s]))
          return !1;
      return !0;
    },
    guid: 0,
    compile: function(t, e) {
      return this.sourceNode = [], this.opcodes = [], this.children = [], this.options = e, this.stringParams = e.stringParams, this.trackIds = e.trackIds, e.blockParams = e.blockParams || [], e.knownHelpers = y.extend(/* @__PURE__ */ Object.create(null), {
        helperMissing: !0,
        blockHelperMissing: !0,
        each: !0,
        if: !0,
        unless: !0,
        with: !0,
        log: !0,
        lookup: !0
      }, e.knownHelpers), this.accept(t);
    },
    compileProgram: function(t) {
      var e = new this.compiler(), s = e.compile(t, this.options), o = this.guid++;
      return this.usePartial = this.usePartial || s.usePartial, this.children[o] = s, this.useDepths = this.useDepths || s.useDepths, o;
    },
    accept: function(t) {
      if (!this[t.type])
        throw new b.default("Unknown type: " + t.type, t);
      this.sourceNode.unshift(t);
      var e = this[t.type](t);
      return this.sourceNode.shift(), e;
    },
    Program: function(t) {
      this.options.blockParams.unshift(t.blockParams);
      for (var e = t.body, s = e.length, o = 0; o < s; o++)
        this.accept(e[o]);
      return this.options.blockParams.shift(), this.isSimple = s === 1, this.blockParams = t.blockParams ? t.blockParams.length : 0, this;
    },
    BlockStatement: function(t) {
      c(t);
      var e = t.program, s = t.inverse;
      e = e && this.compileProgram(e), s = s && this.compileProgram(s);
      var o = this.classifySexpr(t);
      o === "helper" ? this.helperSexpr(t, e, s) : o === "simple" ? (this.simpleSexpr(t), this.opcode("pushProgram", e), this.opcode("pushProgram", s), this.opcode("emptyHash"), this.opcode("blockValue", t.path.original)) : (this.ambiguousSexpr(t, e, s), this.opcode("pushProgram", e), this.opcode("pushProgram", s), this.opcode("emptyHash"), this.opcode("ambiguousBlockValue")), this.opcode("append");
    },
    DecoratorBlock: function(t) {
      var e = t.program && this.compileProgram(t.program), s = this.setupFullMustacheParams(t, e, void 0), o = t.path;
      this.useDecorators = !0, this.opcode("registerDecorator", s.length, o.original);
    },
    PartialStatement: function(t) {
      this.usePartial = !0;
      var e = t.program;
      e && (e = this.compileProgram(t.program));
      var s = t.params;
      if (s.length > 1)
        throw new b.default("Unsupported number of partial arguments: " + s.length, t);
      s.length || (this.options.explicitPartialContext ? this.opcode("pushLiteral", "undefined") : s.push({ type: "PathExpression", parts: [], depth: 0 }));
      var o = t.name.original, f = t.name.type === "SubExpression";
      f && this.accept(t.name), this.setupFullMustacheParams(t, e, void 0, !0);
      var v = t.indent || "";
      this.options.preventIndent && v && (this.opcode("appendContent", v), v = ""), this.opcode("invokePartial", f, o, v), this.opcode("append");
    },
    PartialBlockStatement: function(t) {
      this.PartialStatement(t);
    },
    MustacheStatement: function(t) {
      this.SubExpression(t), t.escaped && !this.options.noEscape ? this.opcode("appendEscaped") : this.opcode("append");
    },
    Decorator: function(t) {
      this.DecoratorBlock(t);
    },
    ContentStatement: function(t) {
      t.value && this.opcode("appendContent", t.value);
    },
    CommentStatement: function() {
    },
    SubExpression: function(t) {
      c(t);
      var e = this.classifySexpr(t);
      e === "simple" ? this.simpleSexpr(t) : e === "helper" ? this.helperSexpr(t) : this.ambiguousSexpr(t);
    },
    ambiguousSexpr: function(t, e, s) {
      var o = t.path, f = o.parts[0], v = e != null || s != null;
      this.opcode("getContext", o.depth), this.opcode("pushProgram", e), this.opcode("pushProgram", s), o.strict = !0, this.accept(o), this.opcode("invokeAmbiguous", f, v);
    },
    simpleSexpr: function(t) {
      var e = t.path;
      e.strict = !0, this.accept(e), this.opcode("resolvePossibleLambda");
    },
    helperSexpr: function(t, e, s) {
      var o = this.setupFullMustacheParams(t, e, s), f = t.path, v = f.parts[0];
      if (this.options.knownHelpers[v])
        this.opcode("invokeKnownHelper", o.length, v);
      else {
        if (this.options.knownHelpersOnly)
          throw new b.default("You specified knownHelpersOnly, but used the unknown helper " + v, t);
        f.strict = !0, f.falsy = !0, this.accept(f), this.opcode("invokeHelper", o.length, f.original, h.default.helpers.simpleId(f));
      }
    },
    PathExpression: function(t) {
      this.addDepth(t.depth), this.opcode("getContext", t.depth);
      var e = t.parts[0], s = h.default.helpers.scopedId(t), o = !t.depth && !s && this.blockParamIndex(e);
      o ? this.opcode("lookupBlockParam", o, t.parts) : e ? t.data ? (this.options.data = !0, this.opcode("lookupData", t.depth, t.parts, t.strict)) : this.opcode("lookupOnContext", t.parts, t.falsy, t.strict, s) : this.opcode("pushContext");
    },
    StringLiteral: function(t) {
      this.opcode("pushString", t.value);
    },
    NumberLiteral: function(t) {
      this.opcode("pushLiteral", t.value);
    },
    BooleanLiteral: function(t) {
      this.opcode("pushLiteral", t.value);
    },
    UndefinedLiteral: function() {
      this.opcode("pushLiteral", "undefined");
    },
    NullLiteral: function() {
      this.opcode("pushLiteral", "null");
    },
    Hash: function(t) {
      var e = t.pairs, s = 0, o = e.length;
      for (this.opcode("pushHash"); s < o; s++)
        this.pushParam(e[s].value);
      for (; s--; )
        this.opcode("assignToHash", e[s].key);
      this.opcode("popHash");
    },
    // HELPERS
    opcode: function(t) {
      this.opcodes.push({
        opcode: t,
        args: d.call(arguments, 1),
        loc: this.sourceNode[0].loc
      });
    },
    addDepth: function(t) {
      t && (this.useDepths = !0);
    },
    classifySexpr: function(t) {
      var e = h.default.helpers.simpleId(t.path), s = e && !!this.blockParamIndex(t.path.parts[0]), o = !s && h.default.helpers.helperExpression(t), f = !s && (o || e);
      if (f && !o) {
        var v = t.path.parts[0], C = this.options;
        C.knownHelpers[v] ? o = !0 : C.knownHelpersOnly && (f = !1);
      }
      return o ? "helper" : f ? "ambiguous" : "simple";
    },
    pushParams: function(t) {
      for (var e = 0, s = t.length; e < s; e++)
        this.pushParam(t[e]);
    },
    pushParam: function(t) {
      var e = t.value != null ? t.value : t.original || "";
      if (this.stringParams)
        e.replace && (e = e.replace(/^(\.?\.\/)*/g, "").replace(/\//g, ".")), t.depth && this.addDepth(t.depth), this.opcode("getContext", t.depth || 0), this.opcode("pushStringParam", e, t.type), t.type === "SubExpression" && this.accept(t);
      else {
        if (this.trackIds) {
          var s = void 0;
          if (t.parts && !h.default.helpers.scopedId(t) && !t.depth && (s = this.blockParamIndex(t.parts[0])), s) {
            var o = t.parts.slice(1).join(".");
            this.opcode("pushId", "BlockParam", s, o);
          } else
            e = t.original || e, e.replace && (e = e.replace(/^this(?:\.|$)/, "").replace(/^\.\//, "").replace(/^\.$/, "")), this.opcode("pushId", t.type, e);
        }
        this.accept(t);
      }
    },
    setupFullMustacheParams: function(t, e, s, o) {
      var f = t.params;
      return this.pushParams(f), this.opcode("pushProgram", e), this.opcode("pushProgram", s), t.hash ? this.accept(t.hash) : this.opcode("emptyHash", o), f;
    },
    blockParamIndex: function(t) {
      for (var e = 0, s = this.options.blockParams.length; e < s; e++) {
        var o = this.options.blockParams[e], f = o && y.indexOf(o, t);
        if (o && f >= 0)
          return [e, f];
      }
    }
  };
  function i(r, t, e) {
    if (r == null || typeof r != "string" && r.type !== "Program")
      throw new b.default("You must pass a string or Handlebars AST to Handlebars.precompile. You passed " + r);
    t = t || {}, "data" in t || (t.data = !0), t.compat && (t.useDepths = !0);
    var s = e.parse(r, t), o = new e.Compiler().compile(s, t);
    return new e.JavaScriptCompiler().compile(o, t);
  }
  function a(r, t, e) {
    if (t === void 0 && (t = {}), r == null || typeof r != "string" && r.type !== "Program")
      throw new b.default("You must pass a string or Handlebars AST to Handlebars.compile. You passed " + r);
    t = y.extend({}, t), "data" in t || (t.data = !0), t.compat && (t.useDepths = !0);
    var s = void 0;
    function o() {
      var v = e.parse(r, t), C = new e.Compiler().compile(v, t), l = new e.JavaScriptCompiler().compile(C, t, void 0, !0);
      return e.template(l);
    }
    function f(v, C) {
      return s || (s = o()), s.call(this, v, C);
    }
    return f._setup = function(v) {
      return s || (s = o()), s._setup(v);
    }, f._child = function(v, C, l, p) {
      return s || (s = o()), s._child(v, C, l, p);
    }, f;
  }
  function n(r, t) {
    if (r === t)
      return !0;
    if (y.isArray(r) && y.isArray(t) && r.length === t.length) {
      for (var e = 0; e < r.length; e++)
        if (!n(r[e], t[e]))
          return !1;
      return !0;
    }
  }
  function c(r) {
    if (!r.path.parts) {
      var t = r.path;
      r.path = {
        type: "PathExpression",
        data: !1,
        depth: 0,
        parts: [t.original + ""],
        original: t.original + "",
        loc: t.loc
      };
    }
  }
  return $;
}
var Oe = { exports: {} }, Ae = { exports: {} }, se = {}, qe = {}, Re = {}, Ne = {}, Pt;
function Rr() {
  if (Pt) return Ne;
  Pt = 1;
  var g = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".split("");
  return Ne.encode = function(m) {
    if (0 <= m && m < g.length)
      return g[m];
    throw new TypeError("Must be between 0 and 63: " + m);
  }, Ne.decode = function(m) {
    var b = 65, y = 90, k = 97, h = 122, d = 48, u = 57, i = 43, a = 47, n = 26, c = 52;
    return b <= m && m <= y ? m - b : k <= m && m <= h ? m - k + n : d <= m && m <= u ? m - d + c : m == i ? 62 : m == a ? 63 : -1;
  }, Ne;
}
var Mt;
function zt() {
  if (Mt) return Re;
  Mt = 1;
  var g = Rr(), m = 5, b = 1 << m, y = b - 1, k = b;
  function h(u) {
    return u < 0 ? (-u << 1) + 1 : (u << 1) + 0;
  }
  function d(u) {
    var i = (u & 1) === 1, a = u >> 1;
    return i ? -a : a;
  }
  return Re.encode = function(i) {
    var a = "", n, c = h(i);
    do
      n = c & y, c >>>= m, c > 0 && (n |= k), a += g.encode(n);
    while (c > 0);
    return a;
  }, Re.decode = function(i, a, n) {
    var c = i.length, r = 0, t = 0, e, s;
    do {
      if (a >= c)
        throw new Error("Expected more digits in base 64 VLQ value.");
      if (s = g.decode(i.charCodeAt(a++)), s === -1)
        throw new Error("Invalid base64 digit: " + i.charAt(a - 1));
      e = !!(s & k), s &= y, r = r + (s << t), t += m;
    } while (e);
    n.value = d(r), n.rest = a;
  }, Re;
}
var Be = {}, Et;
function oe() {
  return Et || (Et = 1, (function(g) {
    function m(l, p, _) {
      if (p in l)
        return l[p];
      if (arguments.length === 3)
        return _;
      throw new Error('"' + p + '" is a required argument.');
    }
    g.getArg = m;
    var b = /^(?:([\w+\-.]+):)?\/\/(?:(\w+:\w+)@)?([\w.-]*)(?::(\d+))?(.*)$/, y = /^data:.+\,.+$/;
    function k(l) {
      var p = l.match(b);
      return p ? {
        scheme: p[1],
        auth: p[2],
        host: p[3],
        port: p[4],
        path: p[5]
      } : null;
    }
    g.urlParse = k;
    function h(l) {
      var p = "";
      return l.scheme && (p += l.scheme + ":"), p += "//", l.auth && (p += l.auth + "@"), l.host && (p += l.host), l.port && (p += ":" + l.port), l.path && (p += l.path), p;
    }
    g.urlGenerate = h;
    function d(l) {
      var p = l, _ = k(l);
      if (_) {
        if (!_.path)
          return l;
        p = _.path;
      }
      for (var L = g.isAbsolute(p), E = p.split(/\/+/), A, x = 0, S = E.length - 1; S >= 0; S--)
        A = E[S], A === "." ? E.splice(S, 1) : A === ".." ? x++ : x > 0 && (A === "" ? (E.splice(S + 1, x), x = 0) : (E.splice(S, 2), x--));
      return p = E.join("/"), p === "" && (p = L ? "/" : "."), _ ? (_.path = p, h(_)) : p;
    }
    g.normalize = d;
    function u(l, p) {
      l === "" && (l = "."), p === "" && (p = ".");
      var _ = k(p), L = k(l);
      if (L && (l = L.path || "/"), _ && !_.scheme)
        return L && (_.scheme = L.scheme), h(_);
      if (_ || p.match(y))
        return p;
      if (L && !L.host && !L.path)
        return L.host = p, h(L);
      var E = p.charAt(0) === "/" ? p : d(l.replace(/\/+$/, "") + "/" + p);
      return L ? (L.path = E, h(L)) : E;
    }
    g.join = u, g.isAbsolute = function(l) {
      return l.charAt(0) === "/" || b.test(l);
    };
    function i(l, p) {
      l === "" && (l = "."), l = l.replace(/\/$/, "");
      for (var _ = 0; p.indexOf(l + "/") !== 0; ) {
        var L = l.lastIndexOf("/");
        if (L < 0 || (l = l.slice(0, L), l.match(/^([^\/]+:\/)?\/*$/)))
          return p;
        ++_;
      }
      return Array(_ + 1).join("../") + p.substr(l.length + 1);
    }
    g.relative = i;
    var a = (function() {
      var l = /* @__PURE__ */ Object.create(null);
      return !("__proto__" in l);
    })();
    function n(l) {
      return l;
    }
    function c(l) {
      return t(l) ? "$" + l : l;
    }
    g.toSetString = a ? n : c;
    function r(l) {
      return t(l) ? l.slice(1) : l;
    }
    g.fromSetString = a ? n : r;
    function t(l) {
      if (!l)
        return !1;
      var p = l.length;
      if (p < 9 || l.charCodeAt(p - 1) !== 95 || l.charCodeAt(p - 2) !== 95 || l.charCodeAt(p - 3) !== 111 || l.charCodeAt(p - 4) !== 116 || l.charCodeAt(p - 5) !== 111 || l.charCodeAt(p - 6) !== 114 || l.charCodeAt(p - 7) !== 112 || l.charCodeAt(p - 8) !== 95 || l.charCodeAt(p - 9) !== 95)
        return !1;
      for (var _ = p - 10; _ >= 0; _--)
        if (l.charCodeAt(_) !== 36)
          return !1;
      return !0;
    }
    function e(l, p, _) {
      var L = o(l.source, p.source);
      return L !== 0 || (L = l.originalLine - p.originalLine, L !== 0) || (L = l.originalColumn - p.originalColumn, L !== 0 || _) || (L = l.generatedColumn - p.generatedColumn, L !== 0) || (L = l.generatedLine - p.generatedLine, L !== 0) ? L : o(l.name, p.name);
    }
    g.compareByOriginalPositions = e;
    function s(l, p, _) {
      var L = l.generatedLine - p.generatedLine;
      return L !== 0 || (L = l.generatedColumn - p.generatedColumn, L !== 0 || _) || (L = o(l.source, p.source), L !== 0) || (L = l.originalLine - p.originalLine, L !== 0) || (L = l.originalColumn - p.originalColumn, L !== 0) ? L : o(l.name, p.name);
    }
    g.compareByGeneratedPositionsDeflated = s;
    function o(l, p) {
      return l === p ? 0 : l === null ? 1 : p === null ? -1 : l > p ? 1 : -1;
    }
    function f(l, p) {
      var _ = l.generatedLine - p.generatedLine;
      return _ !== 0 || (_ = l.generatedColumn - p.generatedColumn, _ !== 0) || (_ = o(l.source, p.source), _ !== 0) || (_ = l.originalLine - p.originalLine, _ !== 0) || (_ = l.originalColumn - p.originalColumn, _ !== 0) ? _ : o(l.name, p.name);
    }
    g.compareByGeneratedPositionsInflated = f;
    function v(l) {
      return JSON.parse(l.replace(/^\)]}'[^\n]*\n/, ""));
    }
    g.parseSourceMapInput = v;
    function C(l, p, _) {
      if (p = p || "", l && (l[l.length - 1] !== "/" && p[0] !== "/" && (l += "/"), p = l + p), _) {
        var L = k(_);
        if (!L)
          throw new Error("sourceMapURL could not be parsed");
        if (L.path) {
          var E = L.path.lastIndexOf("/");
          E >= 0 && (L.path = L.path.substring(0, E + 1));
        }
        p = u(h(L), p);
      }
      return d(p);
    }
    g.computeSourceURL = C;
  })(Be)), Be;
}
var Ve = {}, xt;
function Kt() {
  if (xt) return Ve;
  xt = 1;
  var g = oe(), m = Object.prototype.hasOwnProperty, b = typeof Map != "undefined";
  function y() {
    this._array = [], this._set = b ? /* @__PURE__ */ new Map() : /* @__PURE__ */ Object.create(null);
  }
  return y.fromArray = function(h, d) {
    for (var u = new y(), i = 0, a = h.length; i < a; i++)
      u.add(h[i], d);
    return u;
  }, y.prototype.size = function() {
    return b ? this._set.size : Object.getOwnPropertyNames(this._set).length;
  }, y.prototype.add = function(h, d) {
    var u = b ? h : g.toSetString(h), i = b ? this.has(h) : m.call(this._set, u), a = this._array.length;
    (!i || d) && this._array.push(h), i || (b ? this._set.set(h, a) : this._set[u] = a);
  }, y.prototype.has = function(h) {
    if (b)
      return this._set.has(h);
    var d = g.toSetString(h);
    return m.call(this._set, d);
  }, y.prototype.indexOf = function(h) {
    if (b) {
      var d = this._set.get(h);
      if (d >= 0)
        return d;
    } else {
      var u = g.toSetString(h);
      if (m.call(this._set, u))
        return this._set[u];
    }
    throw new Error('"' + h + '" is not in the set.');
  }, y.prototype.at = function(h) {
    if (h >= 0 && h < this._array.length)
      return this._array[h];
    throw new Error("No element indexed by " + h);
  }, y.prototype.toArray = function() {
    return this._array.slice();
  }, Ve.ArraySet = y, Ve;
}
var Fe = {}, wt;
function Nr() {
  if (wt) return Fe;
  wt = 1;
  var g = oe();
  function m(y, k) {
    var h = y.generatedLine, d = k.generatedLine, u = y.generatedColumn, i = k.generatedColumn;
    return d > h || d == h && i >= u || g.compareByGeneratedPositionsInflated(y, k) <= 0;
  }
  function b() {
    this._array = [], this._sorted = !0, this._last = { generatedLine: -1, generatedColumn: 0 };
  }
  return b.prototype.unsortedForEach = function(k, h) {
    this._array.forEach(k, h);
  }, b.prototype.add = function(k) {
    m(this._last, k) ? (this._last = k, this._array.push(k)) : (this._sorted = !1, this._array.push(k));
  }, b.prototype.toArray = function() {
    return this._sorted || (this._array.sort(g.compareByGeneratedPositionsInflated), this._sorted = !0), this._array;
  }, Fe.MappingList = b, Fe;
}
var Ot;
function Qt() {
  if (Ot) return qe;
  Ot = 1;
  var g = zt(), m = oe(), b = Kt().ArraySet, y = Nr().MappingList;
  function k(h) {
    h || (h = {}), this._file = m.getArg(h, "file", null), this._sourceRoot = m.getArg(h, "sourceRoot", null), this._skipValidation = m.getArg(h, "skipValidation", !1), this._sources = new b(), this._names = new b(), this._mappings = new y(), this._sourcesContents = null;
  }
  return k.prototype._version = 3, k.fromSourceMap = function(d) {
    var u = d.sourceRoot, i = new k({
      file: d.file,
      sourceRoot: u
    });
    return d.eachMapping(function(a) {
      var n = {
        generated: {
          line: a.generatedLine,
          column: a.generatedColumn
        }
      };
      a.source != null && (n.source = a.source, u != null && (n.source = m.relative(u, n.source)), n.original = {
        line: a.originalLine,
        column: a.originalColumn
      }, a.name != null && (n.name = a.name)), i.addMapping(n);
    }), d.sources.forEach(function(a) {
      var n = a;
      u !== null && (n = m.relative(u, a)), i._sources.has(n) || i._sources.add(n);
      var c = d.sourceContentFor(a);
      c != null && i.setSourceContent(a, c);
    }), i;
  }, k.prototype.addMapping = function(d) {
    var u = m.getArg(d, "generated"), i = m.getArg(d, "original", null), a = m.getArg(d, "source", null), n = m.getArg(d, "name", null);
    this._skipValidation || this._validateMapping(u, i, a, n), a != null && (a = String(a), this._sources.has(a) || this._sources.add(a)), n != null && (n = String(n), this._names.has(n) || this._names.add(n)), this._mappings.add({
      generatedLine: u.line,
      generatedColumn: u.column,
      originalLine: i != null && i.line,
      originalColumn: i != null && i.column,
      source: a,
      name: n
    });
  }, k.prototype.setSourceContent = function(d, u) {
    var i = d;
    this._sourceRoot != null && (i = m.relative(this._sourceRoot, i)), u != null ? (this._sourcesContents || (this._sourcesContents = /* @__PURE__ */ Object.create(null)), this._sourcesContents[m.toSetString(i)] = u) : this._sourcesContents && (delete this._sourcesContents[m.toSetString(i)], Object.keys(this._sourcesContents).length === 0 && (this._sourcesContents = null));
  }, k.prototype.applySourceMap = function(d, u, i) {
    var a = u;
    if (u == null) {
      if (d.file == null)
        throw new Error(
          `SourceMapGenerator.prototype.applySourceMap requires either an explicit source file, or the source map's "file" property. Both were omitted.`
        );
      a = d.file;
    }
    var n = this._sourceRoot;
    n != null && (a = m.relative(n, a));
    var c = new b(), r = new b();
    this._mappings.unsortedForEach(function(t) {
      if (t.source === a && t.originalLine != null) {
        var e = d.originalPositionFor({
          line: t.originalLine,
          column: t.originalColumn
        });
        e.source != null && (t.source = e.source, i != null && (t.source = m.join(i, t.source)), n != null && (t.source = m.relative(n, t.source)), t.originalLine = e.line, t.originalColumn = e.column, e.name != null && (t.name = e.name));
      }
      var s = t.source;
      s != null && !c.has(s) && c.add(s);
      var o = t.name;
      o != null && !r.has(o) && r.add(o);
    }, this), this._sources = c, this._names = r, d.sources.forEach(function(t) {
      var e = d.sourceContentFor(t);
      e != null && (i != null && (t = m.join(i, t)), n != null && (t = m.relative(n, t)), this.setSourceContent(t, e));
    }, this);
  }, k.prototype._validateMapping = function(d, u, i, a) {
    if (u && typeof u.line != "number" && typeof u.column != "number")
      throw new Error(
        "original.line and original.column are not numbers -- you probably meant to omit the original mapping entirely and only map the generated position. If so, pass null for the original mapping instead of an object with empty or null values."
      );
    if (!(d && "line" in d && "column" in d && d.line > 0 && d.column >= 0 && !u && !i && !a)) {
      if (d && "line" in d && "column" in d && u && "line" in u && "column" in u && d.line > 0 && d.column >= 0 && u.line > 0 && u.column >= 0 && i)
        return;
      throw new Error("Invalid mapping: " + JSON.stringify({
        generated: d,
        source: i,
        original: u,
        name: a
      }));
    }
  }, k.prototype._serializeMappings = function() {
    for (var d = 0, u = 1, i = 0, a = 0, n = 0, c = 0, r = "", t, e, s, o, f = this._mappings.toArray(), v = 0, C = f.length; v < C; v++) {
      if (e = f[v], t = "", e.generatedLine !== u)
        for (d = 0; e.generatedLine !== u; )
          t += ";", u++;
      else if (v > 0) {
        if (!m.compareByGeneratedPositionsInflated(e, f[v - 1]))
          continue;
        t += ",";
      }
      t += g.encode(e.generatedColumn - d), d = e.generatedColumn, e.source != null && (o = this._sources.indexOf(e.source), t += g.encode(o - c), c = o, t += g.encode(e.originalLine - 1 - a), a = e.originalLine - 1, t += g.encode(e.originalColumn - i), i = e.originalColumn, e.name != null && (s = this._names.indexOf(e.name), t += g.encode(s - n), n = s)), r += t;
    }
    return r;
  }, k.prototype._generateSourcesContent = function(d, u) {
    return d.map(function(i) {
      if (!this._sourcesContents)
        return null;
      u != null && (i = m.relative(u, i));
      var a = m.toSetString(i);
      return Object.prototype.hasOwnProperty.call(this._sourcesContents, a) ? this._sourcesContents[a] : null;
    }, this);
  }, k.prototype.toJSON = function() {
    var d = {
      version: this._version,
      sources: this._sources.toArray(),
      names: this._names.toArray(),
      mappings: this._serializeMappings()
    };
    return this._file != null && (d.file = this._file), this._sourceRoot != null && (d.sourceRoot = this._sourceRoot), this._sourcesContents && (d.sourcesContent = this._generateSourcesContent(d.sources, d.sourceRoot)), d;
  }, k.prototype.toString = function() {
    return JSON.stringify(this.toJSON());
  }, qe.SourceMapGenerator = k, qe;
}
var ae = {}, Ge = {}, At;
function Ir() {
  return At || (At = 1, (function(g) {
    g.GREATEST_LOWER_BOUND = 1, g.LEAST_UPPER_BOUND = 2;
    function m(b, y, k, h, d, u) {
      var i = Math.floor((y - b) / 2) + b, a = d(k, h[i], !0);
      return a === 0 ? i : a > 0 ? y - i > 1 ? m(i, y, k, h, d, u) : u == g.LEAST_UPPER_BOUND ? y < h.length ? y : -1 : i : i - b > 1 ? m(b, i, k, h, d, u) : u == g.LEAST_UPPER_BOUND ? i : b < 0 ? -1 : b;
    }
    g.search = function(y, k, h, d) {
      if (k.length === 0)
        return -1;
      var u = m(
        -1,
        k.length,
        y,
        k,
        h,
        d || g.GREATEST_LOWER_BOUND
      );
      if (u < 0)
        return -1;
      for (; u - 1 >= 0 && h(k[u], k[u - 1], !0) === 0; )
        --u;
      return u;
    };
  })(Ge)), Ge;
}
var Ue = {}, Rt;
function Hr() {
  if (Rt) return Ue;
  Rt = 1;
  function g(y, k, h) {
    var d = y[k];
    y[k] = y[h], y[h] = d;
  }
  function m(y, k) {
    return Math.round(y + Math.random() * (k - y));
  }
  function b(y, k, h, d) {
    if (h < d) {
      var u = m(h, d), i = h - 1;
      g(y, u, d);
      for (var a = y[d], n = h; n < d; n++)
        k(y[n], a) <= 0 && (i += 1, g(y, i, n));
      g(y, i + 1, n);
      var c = i + 1;
      b(y, k, h, c - 1), b(y, k, c + 1, d);
    }
  }
  return Ue.quickSort = function(y, k) {
    b(y, k, 0, y.length - 1);
  }, Ue;
}
var Nt;
function Tr() {
  if (Nt) return ae;
  Nt = 1;
  var g = oe(), m = Ir(), b = Kt().ArraySet, y = zt(), k = Hr().quickSort;
  function h(a, n) {
    var c = a;
    return typeof a == "string" && (c = g.parseSourceMapInput(a)), c.sections != null ? new i(c, n) : new d(c, n);
  }
  h.fromSourceMap = function(a, n) {
    return d.fromSourceMap(a, n);
  }, h.prototype._version = 3, h.prototype.__generatedMappings = null, Object.defineProperty(h.prototype, "_generatedMappings", {
    configurable: !0,
    enumerable: !0,
    get: function() {
      return this.__generatedMappings || this._parseMappings(this._mappings, this.sourceRoot), this.__generatedMappings;
    }
  }), h.prototype.__originalMappings = null, Object.defineProperty(h.prototype, "_originalMappings", {
    configurable: !0,
    enumerable: !0,
    get: function() {
      return this.__originalMappings || this._parseMappings(this._mappings, this.sourceRoot), this.__originalMappings;
    }
  }), h.prototype._charIsMappingSeparator = function(n, c) {
    var r = n.charAt(c);
    return r === ";" || r === ",";
  }, h.prototype._parseMappings = function(n, c) {
    throw new Error("Subclasses must implement _parseMappings");
  }, h.GENERATED_ORDER = 1, h.ORIGINAL_ORDER = 2, h.GREATEST_LOWER_BOUND = 1, h.LEAST_UPPER_BOUND = 2, h.prototype.eachMapping = function(n, c, r) {
    var t = c || null, e = r || h.GENERATED_ORDER, s;
    switch (e) {
      case h.GENERATED_ORDER:
        s = this._generatedMappings;
        break;
      case h.ORIGINAL_ORDER:
        s = this._originalMappings;
        break;
      default:
        throw new Error("Unknown order of iteration.");
    }
    var o = this.sourceRoot;
    s.map(function(f) {
      var v = f.source === null ? null : this._sources.at(f.source);
      return v = g.computeSourceURL(o, v, this._sourceMapURL), {
        source: v,
        generatedLine: f.generatedLine,
        generatedColumn: f.generatedColumn,
        originalLine: f.originalLine,
        originalColumn: f.originalColumn,
        name: f.name === null ? null : this._names.at(f.name)
      };
    }, this).forEach(n, t);
  }, h.prototype.allGeneratedPositionsFor = function(n) {
    var c = g.getArg(n, "line"), r = {
      source: g.getArg(n, "source"),
      originalLine: c,
      originalColumn: g.getArg(n, "column", 0)
    };
    if (r.source = this._findSourceIndex(r.source), r.source < 0)
      return [];
    var t = [], e = this._findMapping(
      r,
      this._originalMappings,
      "originalLine",
      "originalColumn",
      g.compareByOriginalPositions,
      m.LEAST_UPPER_BOUND
    );
    if (e >= 0) {
      var s = this._originalMappings[e];
      if (n.column === void 0)
        for (var o = s.originalLine; s && s.originalLine === o; )
          t.push({
            line: g.getArg(s, "generatedLine", null),
            column: g.getArg(s, "generatedColumn", null),
            lastColumn: g.getArg(s, "lastGeneratedColumn", null)
          }), s = this._originalMappings[++e];
      else
        for (var f = s.originalColumn; s && s.originalLine === c && s.originalColumn == f; )
          t.push({
            line: g.getArg(s, "generatedLine", null),
            column: g.getArg(s, "generatedColumn", null),
            lastColumn: g.getArg(s, "lastGeneratedColumn", null)
          }), s = this._originalMappings[++e];
    }
    return t;
  }, ae.SourceMapConsumer = h;
  function d(a, n) {
    var c = a;
    typeof a == "string" && (c = g.parseSourceMapInput(a));
    var r = g.getArg(c, "version"), t = g.getArg(c, "sources"), e = g.getArg(c, "names", []), s = g.getArg(c, "sourceRoot", null), o = g.getArg(c, "sourcesContent", null), f = g.getArg(c, "mappings"), v = g.getArg(c, "file", null);
    if (r != this._version)
      throw new Error("Unsupported version: " + r);
    s && (s = g.normalize(s)), t = t.map(String).map(g.normalize).map(function(C) {
      return s && g.isAbsolute(s) && g.isAbsolute(C) ? g.relative(s, C) : C;
    }), this._names = b.fromArray(e.map(String), !0), this._sources = b.fromArray(t, !0), this._absoluteSources = this._sources.toArray().map(function(C) {
      return g.computeSourceURL(s, C, n);
    }), this.sourceRoot = s, this.sourcesContent = o, this._mappings = f, this._sourceMapURL = n, this.file = v;
  }
  d.prototype = Object.create(h.prototype), d.prototype.consumer = h, d.prototype._findSourceIndex = function(a) {
    var n = a;
    if (this.sourceRoot != null && (n = g.relative(this.sourceRoot, n)), this._sources.has(n))
      return this._sources.indexOf(n);
    var c;
    for (c = 0; c < this._absoluteSources.length; ++c)
      if (this._absoluteSources[c] == a)
        return c;
    return -1;
  }, d.fromSourceMap = function(n, c) {
    var r = Object.create(d.prototype), t = r._names = b.fromArray(n._names.toArray(), !0), e = r._sources = b.fromArray(n._sources.toArray(), !0);
    r.sourceRoot = n._sourceRoot, r.sourcesContent = n._generateSourcesContent(
      r._sources.toArray(),
      r.sourceRoot
    ), r.file = n._file, r._sourceMapURL = c, r._absoluteSources = r._sources.toArray().map(function(_) {
      return g.computeSourceURL(r.sourceRoot, _, c);
    });
    for (var s = n._mappings.toArray().slice(), o = r.__generatedMappings = [], f = r.__originalMappings = [], v = 0, C = s.length; v < C; v++) {
      var l = s[v], p = new u();
      p.generatedLine = l.generatedLine, p.generatedColumn = l.generatedColumn, l.source && (p.source = e.indexOf(l.source), p.originalLine = l.originalLine, p.originalColumn = l.originalColumn, l.name && (p.name = t.indexOf(l.name)), f.push(p)), o.push(p);
    }
    return k(r.__originalMappings, g.compareByOriginalPositions), r;
  }, d.prototype._version = 3, Object.defineProperty(d.prototype, "sources", {
    get: function() {
      return this._absoluteSources.slice();
    }
  });
  function u() {
    this.generatedLine = 0, this.generatedColumn = 0, this.source = null, this.originalLine = null, this.originalColumn = null, this.name = null;
  }
  d.prototype._parseMappings = function(n, c) {
    for (var r = 1, t = 0, e = 0, s = 0, o = 0, f = 0, v = n.length, C = 0, l = {}, p = {}, _ = [], L = [], E, A, x, S, P; C < v; )
      if (n.charAt(C) === ";")
        r++, C++, t = 0;
      else if (n.charAt(C) === ",")
        C++;
      else {
        for (E = new u(), E.generatedLine = r, S = C; S < v && !this._charIsMappingSeparator(n, S); S++)
          ;
        if (A = n.slice(C, S), x = l[A], x)
          C += A.length;
        else {
          for (x = []; C < S; )
            y.decode(n, C, p), P = p.value, C = p.rest, x.push(P);
          if (x.length === 2)
            throw new Error("Found a source, but no line and column");
          if (x.length === 3)
            throw new Error("Found a source and line, but no column");
          l[A] = x;
        }
        E.generatedColumn = t + x[0], t = E.generatedColumn, x.length > 1 && (E.source = o + x[1], o += x[1], E.originalLine = e + x[2], e = E.originalLine, E.originalLine += 1, E.originalColumn = s + x[3], s = E.originalColumn, x.length > 4 && (E.name = f + x[4], f += x[4])), L.push(E), typeof E.originalLine == "number" && _.push(E);
      }
    k(L, g.compareByGeneratedPositionsDeflated), this.__generatedMappings = L, k(_, g.compareByOriginalPositions), this.__originalMappings = _;
  }, d.prototype._findMapping = function(n, c, r, t, e, s) {
    if (n[r] <= 0)
      throw new TypeError("Line must be greater than or equal to 1, got " + n[r]);
    if (n[t] < 0)
      throw new TypeError("Column must be greater than or equal to 0, got " + n[t]);
    return m.search(n, c, e, s);
  }, d.prototype.computeColumnSpans = function() {
    for (var n = 0; n < this._generatedMappings.length; ++n) {
      var c = this._generatedMappings[n];
      if (n + 1 < this._generatedMappings.length) {
        var r = this._generatedMappings[n + 1];
        if (c.generatedLine === r.generatedLine) {
          c.lastGeneratedColumn = r.generatedColumn - 1;
          continue;
        }
      }
      c.lastGeneratedColumn = 1 / 0;
    }
  }, d.prototype.originalPositionFor = function(n) {
    var c = {
      generatedLine: g.getArg(n, "line"),
      generatedColumn: g.getArg(n, "column")
    }, r = this._findMapping(
      c,
      this._generatedMappings,
      "generatedLine",
      "generatedColumn",
      g.compareByGeneratedPositionsDeflated,
      g.getArg(n, "bias", h.GREATEST_LOWER_BOUND)
    );
    if (r >= 0) {
      var t = this._generatedMappings[r];
      if (t.generatedLine === c.generatedLine) {
        var e = g.getArg(t, "source", null);
        e !== null && (e = this._sources.at(e), e = g.computeSourceURL(this.sourceRoot, e, this._sourceMapURL));
        var s = g.getArg(t, "name", null);
        return s !== null && (s = this._names.at(s)), {
          source: e,
          line: g.getArg(t, "originalLine", null),
          column: g.getArg(t, "originalColumn", null),
          name: s
        };
      }
    }
    return {
      source: null,
      line: null,
      column: null,
      name: null
    };
  }, d.prototype.hasContentsOfAllSources = function() {
    return this.sourcesContent ? this.sourcesContent.length >= this._sources.size() && !this.sourcesContent.some(function(n) {
      return n == null;
    }) : !1;
  }, d.prototype.sourceContentFor = function(n, c) {
    if (!this.sourcesContent)
      return null;
    var r = this._findSourceIndex(n);
    if (r >= 0)
      return this.sourcesContent[r];
    var t = n;
    this.sourceRoot != null && (t = g.relative(this.sourceRoot, t));
    var e;
    if (this.sourceRoot != null && (e = g.urlParse(this.sourceRoot))) {
      var s = t.replace(/^file:\/\//, "");
      if (e.scheme == "file" && this._sources.has(s))
        return this.sourcesContent[this._sources.indexOf(s)];
      if ((!e.path || e.path == "/") && this._sources.has("/" + t))
        return this.sourcesContent[this._sources.indexOf("/" + t)];
    }
    if (c)
      return null;
    throw new Error('"' + t + '" is not in the SourceMap.');
  }, d.prototype.generatedPositionFor = function(n) {
    var c = g.getArg(n, "source");
    if (c = this._findSourceIndex(c), c < 0)
      return {
        line: null,
        column: null,
        lastColumn: null
      };
    var r = {
      source: c,
      originalLine: g.getArg(n, "line"),
      originalColumn: g.getArg(n, "column")
    }, t = this._findMapping(
      r,
      this._originalMappings,
      "originalLine",
      "originalColumn",
      g.compareByOriginalPositions,
      g.getArg(n, "bias", h.GREATEST_LOWER_BOUND)
    );
    if (t >= 0) {
      var e = this._originalMappings[t];
      if (e.source === r.source)
        return {
          line: g.getArg(e, "generatedLine", null),
          column: g.getArg(e, "generatedColumn", null),
          lastColumn: g.getArg(e, "lastGeneratedColumn", null)
        };
    }
    return {
      line: null,
      column: null,
      lastColumn: null
    };
  }, ae.BasicSourceMapConsumer = d;
  function i(a, n) {
    var c = a;
    typeof a == "string" && (c = g.parseSourceMapInput(a));
    var r = g.getArg(c, "version"), t = g.getArg(c, "sections");
    if (r != this._version)
      throw new Error("Unsupported version: " + r);
    this._sources = new b(), this._names = new b();
    var e = {
      line: -1,
      column: 0
    };
    this._sections = t.map(function(s) {
      if (s.url)
        throw new Error("Support for url field in sections not implemented.");
      var o = g.getArg(s, "offset"), f = g.getArg(o, "line"), v = g.getArg(o, "column");
      if (f < e.line || f === e.line && v < e.column)
        throw new Error("Section offsets must be ordered and non-overlapping.");
      return e = o, {
        generatedOffset: {
          // The offset fields are 0-based, but we use 1-based indices when
          // encoding/decoding from VLQ.
          generatedLine: f + 1,
          generatedColumn: v + 1
        },
        consumer: new h(g.getArg(s, "map"), n)
      };
    });
  }
  return i.prototype = Object.create(h.prototype), i.prototype.constructor = h, i.prototype._version = 3, Object.defineProperty(i.prototype, "sources", {
    get: function() {
      for (var a = [], n = 0; n < this._sections.length; n++)
        for (var c = 0; c < this._sections[n].consumer.sources.length; c++)
          a.push(this._sections[n].consumer.sources[c]);
      return a;
    }
  }), i.prototype.originalPositionFor = function(n) {
    var c = {
      generatedLine: g.getArg(n, "line"),
      generatedColumn: g.getArg(n, "column")
    }, r = m.search(
      c,
      this._sections,
      function(e, s) {
        var o = e.generatedLine - s.generatedOffset.generatedLine;
        return o || e.generatedColumn - s.generatedOffset.generatedColumn;
      }
    ), t = this._sections[r];
    return t ? t.consumer.originalPositionFor({
      line: c.generatedLine - (t.generatedOffset.generatedLine - 1),
      column: c.generatedColumn - (t.generatedOffset.generatedLine === c.generatedLine ? t.generatedOffset.generatedColumn - 1 : 0),
      bias: n.bias
    }) : {
      source: null,
      line: null,
      column: null,
      name: null
    };
  }, i.prototype.hasContentsOfAllSources = function() {
    return this._sections.every(function(n) {
      return n.consumer.hasContentsOfAllSources();
    });
  }, i.prototype.sourceContentFor = function(n, c) {
    for (var r = 0; r < this._sections.length; r++) {
      var t = this._sections[r], e = t.consumer.sourceContentFor(n, !0);
      if (e)
        return e;
    }
    if (c)
      return null;
    throw new Error('"' + n + '" is not in the SourceMap.');
  }, i.prototype.generatedPositionFor = function(n) {
    for (var c = 0; c < this._sections.length; c++) {
      var r = this._sections[c];
      if (r.consumer._findSourceIndex(g.getArg(n, "source")) !== -1) {
        var t = r.consumer.generatedPositionFor(n);
        if (t) {
          var e = {
            line: t.line + (r.generatedOffset.generatedLine - 1),
            column: t.column + (r.generatedOffset.generatedLine === t.line ? r.generatedOffset.generatedColumn - 1 : 0)
          };
          return e;
        }
      }
    }
    return {
      line: null,
      column: null
    };
  }, i.prototype._parseMappings = function(n, c) {
    this.__generatedMappings = [], this.__originalMappings = [];
    for (var r = 0; r < this._sections.length; r++)
      for (var t = this._sections[r], e = t.consumer._generatedMappings, s = 0; s < e.length; s++) {
        var o = e[s], f = t.consumer._sources.at(o.source);
        f = g.computeSourceURL(t.consumer.sourceRoot, f, this._sourceMapURL), this._sources.add(f), f = this._sources.indexOf(f);
        var v = null;
        o.name && (v = t.consumer._names.at(o.name), this._names.add(v), v = this._names.indexOf(v));
        var C = {
          source: f,
          generatedLine: o.generatedLine + (t.generatedOffset.generatedLine - 1),
          generatedColumn: o.generatedColumn + (t.generatedOffset.generatedLine === o.generatedLine ? t.generatedOffset.generatedColumn - 1 : 0),
          originalLine: o.originalLine,
          originalColumn: o.originalColumn,
          name: v
        };
        this.__generatedMappings.push(C), typeof C.originalLine == "number" && this.__originalMappings.push(C);
      }
    k(this.__generatedMappings, g.compareByGeneratedPositionsDeflated), k(this.__originalMappings, g.compareByOriginalPositions);
  }, ae.IndexedSourceMapConsumer = i, ae;
}
var We = {}, It;
function Dr() {
  if (It) return We;
  It = 1;
  var g = Qt().SourceMapGenerator, m = oe(), b = /(\r?\n)/, y = 10, k = "$$$isSourceNode$$$";
  function h(d, u, i, a, n) {
    this.children = [], this.sourceContents = {}, this.line = d == null ? null : d, this.column = u == null ? null : u, this.source = i == null ? null : i, this.name = n == null ? null : n, this[k] = !0, a != null && this.add(a);
  }
  return h.fromStringWithSourceMap = function(u, i, a) {
    var n = new h(), c = u.split(b), r = 0, t = function() {
      var v = l(), C = l() || "";
      return v + C;
      function l() {
        return r < c.length ? c[r++] : void 0;
      }
    }, e = 1, s = 0, o = null;
    return i.eachMapping(function(v) {
      if (o !== null)
        if (e < v.generatedLine)
          f(o, t()), e++, s = 0;
        else {
          var C = c[r] || "", l = C.substr(0, v.generatedColumn - s);
          c[r] = C.substr(v.generatedColumn - s), s = v.generatedColumn, f(o, l), o = v;
          return;
        }
      for (; e < v.generatedLine; )
        n.add(t()), e++;
      if (s < v.generatedColumn) {
        var C = c[r] || "";
        n.add(C.substr(0, v.generatedColumn)), c[r] = C.substr(v.generatedColumn), s = v.generatedColumn;
      }
      o = v;
    }, this), r < c.length && (o && f(o, t()), n.add(c.splice(r).join(""))), i.sources.forEach(function(v) {
      var C = i.sourceContentFor(v);
      C != null && (a != null && (v = m.join(a, v)), n.setSourceContent(v, C));
    }), n;
    function f(v, C) {
      if (v === null || v.source === void 0)
        n.add(C);
      else {
        var l = a ? m.join(a, v.source) : v.source;
        n.add(new h(
          v.originalLine,
          v.originalColumn,
          l,
          C,
          v.name
        ));
      }
    }
  }, h.prototype.add = function(u) {
    if (Array.isArray(u))
      u.forEach(function(i) {
        this.add(i);
      }, this);
    else if (u[k] || typeof u == "string")
      u && this.children.push(u);
    else
      throw new TypeError(
        "Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + u
      );
    return this;
  }, h.prototype.prepend = function(u) {
    if (Array.isArray(u))
      for (var i = u.length - 1; i >= 0; i--)
        this.prepend(u[i]);
    else if (u[k] || typeof u == "string")
      this.children.unshift(u);
    else
      throw new TypeError(
        "Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + u
      );
    return this;
  }, h.prototype.walk = function(u) {
    for (var i, a = 0, n = this.children.length; a < n; a++)
      i = this.children[a], i[k] ? i.walk(u) : i !== "" && u(i, {
        source: this.source,
        line: this.line,
        column: this.column,
        name: this.name
      });
  }, h.prototype.join = function(u) {
    var i, a, n = this.children.length;
    if (n > 0) {
      for (i = [], a = 0; a < n - 1; a++)
        i.push(this.children[a]), i.push(u);
      i.push(this.children[a]), this.children = i;
    }
    return this;
  }, h.prototype.replaceRight = function(u, i) {
    var a = this.children[this.children.length - 1];
    return a[k] ? a.replaceRight(u, i) : typeof a == "string" ? this.children[this.children.length - 1] = a.replace(u, i) : this.children.push("".replace(u, i)), this;
  }, h.prototype.setSourceContent = function(u, i) {
    this.sourceContents[m.toSetString(u)] = i;
  }, h.prototype.walkSourceContents = function(u) {
    for (var i = 0, a = this.children.length; i < a; i++)
      this.children[i][k] && this.children[i].walkSourceContents(u);
    for (var n = Object.keys(this.sourceContents), i = 0, a = n.length; i < a; i++)
      u(m.fromSetString(n[i]), this.sourceContents[n[i]]);
  }, h.prototype.toString = function() {
    var u = "";
    return this.walk(function(i) {
      u += i;
    }), u;
  }, h.prototype.toStringWithSourceMap = function(u) {
    var i = {
      code: "",
      line: 1,
      column: 0
    }, a = new g(u), n = !1, c = null, r = null, t = null, e = null;
    return this.walk(function(s, o) {
      i.code += s, o.source !== null && o.line !== null && o.column !== null ? ((c !== o.source || r !== o.line || t !== o.column || e !== o.name) && a.addMapping({
        source: o.source,
        original: {
          line: o.line,
          column: o.column
        },
        generated: {
          line: i.line,
          column: i.column
        },
        name: o.name
      }), c = o.source, r = o.line, t = o.column, e = o.name, n = !0) : n && (a.addMapping({
        generated: {
          line: i.line,
          column: i.column
        }
      }), c = null, n = !1);
      for (var f = 0, v = s.length; f < v; f++)
        s.charCodeAt(f) === y ? (i.line++, i.column = 0, f + 1 === v ? (c = null, n = !1) : n && a.addMapping({
          source: o.source,
          original: {
            line: o.line,
            column: o.column
          },
          generated: {
            line: i.line,
            column: i.column
          },
          name: o.name
        })) : i.column++;
    }), this.walkSourceContents(function(s, o) {
      a.setSourceContent(s, o);
    }), { code: i.code, map: a };
  }, We.SourceNode = h, We;
}
var Ht;
function qr() {
  return Ht || (Ht = 1, se.SourceMapGenerator = Qt().SourceMapGenerator, se.SourceMapConsumer = Tr().SourceMapConsumer, se.SourceNode = Dr().SourceNode), se;
}
var Tt;
function Br() {
  return Tt || (Tt = 1, (function(g, m) {
    m.__esModule = !0;
    var b = D(), y = void 0;
    try {
      var k = qr();
      y = k.SourceNode;
    } catch (u) {
    }
    y || (y = function(u, i, a, n) {
      this.src = "", n && this.add(n);
    }, y.prototype = {
      add: function(i) {
        b.isArray(i) && (i = i.join("")), this.src += i;
      },
      prepend: function(i) {
        b.isArray(i) && (i = i.join("")), this.src = i + this.src;
      },
      toStringWithSourceMap: function() {
        return { code: this.toString() };
      },
      toString: function() {
        return this.src;
      }
    });
    function h(u, i, a) {
      if (b.isArray(u)) {
        for (var n = [], c = 0, r = u.length; c < r; c++)
          n.push(i.wrap(u[c], a));
        return n;
      } else if (typeof u == "boolean" || typeof u == "number")
        return u + "";
      return u;
    }
    function d(u) {
      this.srcFile = u, this.source = [];
    }
    d.prototype = {
      isEmpty: function() {
        return !this.source.length;
      },
      prepend: function(i, a) {
        this.source.unshift(this.wrap(i, a));
      },
      push: function(i, a) {
        this.source.push(this.wrap(i, a));
      },
      merge: function() {
        var i = this.empty();
        return this.each(function(a) {
          i.add(["  ", a, `
`]);
        }), i;
      },
      each: function(i) {
        for (var a = 0, n = this.source.length; a < n; a++)
          i(this.source[a]);
      },
      empty: function() {
        var i = this.currentLocation || { start: {} };
        return new y(i.start.line, i.start.column, this.srcFile);
      },
      wrap: function(i) {
        var a = arguments.length <= 1 || arguments[1] === void 0 ? this.currentLocation || { start: {} } : arguments[1];
        return i instanceof y ? i : (i = h(i, this, a), new y(a.start.line, a.start.column, this.srcFile, i));
      },
      functionCall: function(i, a, n) {
        return n = this.generateList(n), this.wrap([i, a ? "." + a + "(" : "(", n, ")"]);
      },
      quotedString: function(i) {
        return '"' + (i + "").replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029") + '"';
      },
      objectLiteral: function(i) {
        var a = this, n = [];
        Object.keys(i).forEach(function(r) {
          var t = h(i[r], a);
          t !== "undefined" && n.push([a.quotedString(r), ":", t]);
        });
        var c = this.generateList(n);
        return c.prepend("{"), c.add("}"), c;
      },
      generateList: function(i) {
        for (var a = this.empty(), n = 0, c = i.length; n < c; n++)
          n && a.add(","), a.add(h(i[n], this));
        return a;
      },
      generateArray: function(i) {
        var a = this.generateList(i);
        return a.prepend("["), a.add("]"), a;
      }
    }, m.default = d, g.exports = m.default;
  })(Ae, Ae.exports)), Ae.exports;
}
var Dt;
function Vr() {
  return Dt || (Dt = 1, (function(g, m) {
    m.__esModule = !0;
    function b(r) {
      return r && r.__esModule ? r : { default: r };
    }
    var y = ze(), k = G(), h = b(k), d = D(), u = Br(), i = b(u);
    function a(r) {
      this.value = r;
    }
    function n() {
    }
    n.prototype = {
      // PUBLIC API: You can override these methods in a subclass to provide
      // alternative compiled forms for name lookup and buffering semantics
      nameLookup: function(t, e) {
        return this.internalNameLookup(t, e);
      },
      depthedLookup: function(t) {
        return [this.aliasable("container.lookup"), "(depths, ", JSON.stringify(t), ")"];
      },
      compilerInfo: function() {
        var t = y.COMPILER_REVISION, e = y.REVISION_CHANGES[t];
        return [t, e];
      },
      appendToBuffer: function(t, e, s) {
        return d.isArray(t) || (t = [t]), t = this.source.wrap(t, e), this.environment.isSimple ? ["return ", t, ";"] : s ? ["buffer += ", t, ";"] : (t.appendToBuffer = !0, t);
      },
      initializeBuffer: function() {
        return this.quotedString("");
      },
      // END PUBLIC API
      internalNameLookup: function(t, e) {
        return this.lookupPropertyFunctionIsUsed = !0, ["lookupProperty(", t, ",", JSON.stringify(e), ")"];
      },
      lookupPropertyFunctionIsUsed: !1,
      compile: function(t, e, s, o) {
        this.environment = t, this.options = e, this.stringParams = this.options.stringParams, this.trackIds = this.options.trackIds, this.precompile = !o, this.name = this.environment.name, this.isChild = !!s, this.context = s || {
          decorators: [],
          programs: [],
          environments: []
        }, this.preamble(), this.stackSlot = 0, this.stackVars = [], this.aliases = {}, this.registers = { list: [] }, this.hashes = [], this.compileStack = [], this.inlineStack = [], this.blockParams = [], this.compileChildren(t, e), this.useDepths = this.useDepths || t.useDepths || t.useDecorators || this.options.compat, this.useBlockParams = this.useBlockParams || t.useBlockParams;
        var f = t.opcodes, v = void 0, C = void 0, l = void 0, p = void 0;
        for (l = 0, p = f.length; l < p; l++)
          v = f[l], this.source.currentLocation = v.loc, C = C || v.loc, this[v.opcode].apply(this, v.args);
        if (this.source.currentLocation = C, this.pushSource(""), this.stackSlot || this.inlineStack.length || this.compileStack.length)
          throw new h.default("Compile completed with content left on stack");
        this.decorators.isEmpty() ? this.decorators = void 0 : (this.useDecorators = !0, this.decorators.prepend(["var decorators = container.decorators, ", this.lookupPropertyFunctionVarDeclaration(), `;
`]), this.decorators.push("return fn;"), o ? this.decorators = Function.apply(this, ["fn", "props", "container", "depth0", "data", "blockParams", "depths", this.decorators.merge()]) : (this.decorators.prepend(`function(fn, props, container, depth0, data, blockParams, depths) {
`), this.decorators.push(`}
`), this.decorators = this.decorators.merge()));
        var _ = this.createFunctionContext(o);
        if (this.isChild)
          return _;
        var L = {
          compiler: this.compilerInfo(),
          main: _
        };
        this.decorators && (L.main_d = this.decorators, L.useDecorators = !0);
        var E = this.context, A = E.programs, x = E.decorators;
        for (l = 0, p = A.length; l < p; l++)
          A[l] && (L[l] = A[l], x[l] && (L[l + "_d"] = x[l], L.useDecorators = !0));
        return this.environment.usePartial && (L.usePartial = !0), this.options.data && (L.useData = !0), this.useDepths && (L.useDepths = !0), this.useBlockParams && (L.useBlockParams = !0), this.options.compat && (L.compat = !0), o ? L.compilerOptions = this.options : (L.compiler = JSON.stringify(L.compiler), this.source.currentLocation = { start: { line: 1, column: 0 } }, L = this.objectLiteral(L), e.srcName ? (L = L.toStringWithSourceMap({ file: e.destName }), L.map = L.map && L.map.toString()) : L = L.toString()), L;
      },
      preamble: function() {
        this.lastContext = 0, this.source = new i.default(this.options.srcName), this.decorators = new i.default(this.options.srcName);
      },
      createFunctionContext: function(t) {
        var e = this, s = "", o = this.stackVars.concat(this.registers.list);
        o.length > 0 && (s += ", " + o.join(", "));
        var f = 0;
        Object.keys(this.aliases).forEach(function(l) {
          var p = e.aliases[l];
          p.children && p.referenceCount > 1 && (s += ", alias" + ++f + "=" + l, p.children[0] = "alias" + f);
        }), this.lookupPropertyFunctionIsUsed && (s += ", " + this.lookupPropertyFunctionVarDeclaration());
        var v = ["container", "depth0", "helpers", "partials", "data"];
        (this.useBlockParams || this.useDepths) && v.push("blockParams"), this.useDepths && v.push("depths");
        var C = this.mergeSource(s);
        return t ? (v.push(C), Function.apply(this, v)) : this.source.wrap(["function(", v.join(","), `) {
  `, C, "}"]);
      },
      mergeSource: function(t) {
        var e = this.environment.isSimple, s = !this.forceBuffer, o = void 0, f = void 0, v = void 0, C = void 0;
        return this.source.each(function(l) {
          l.appendToBuffer ? (v ? l.prepend("  + ") : v = l, C = l) : (v && (f ? v.prepend("buffer += ") : o = !0, C.add(";"), v = C = void 0), f = !0, e || (s = !1));
        }), s ? v ? (v.prepend("return "), C.add(";")) : f || this.source.push('return "";') : (t += ", buffer = " + (o ? "" : this.initializeBuffer()), v ? (v.prepend("return buffer + "), C.add(";")) : this.source.push("return buffer;")), t && this.source.prepend("var " + t.substring(2) + (o ? "" : `;
`)), this.source.merge();
      },
      lookupPropertyFunctionVarDeclaration: function() {
        return `
      lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    }
    `.trim();
      },
      // [blockValue]
      //
      // On stack, before: hash, inverse, program, value
      // On stack, after: return value of blockHelperMissing
      //
      // The purpose of this opcode is to take a block of the form
      // `{{#this.foo}}...{{/this.foo}}`, resolve the value of `foo`, and
      // replace it on the stack with the result of properly
      // invoking blockHelperMissing.
      blockValue: function(t) {
        var e = this.aliasable("container.hooks.blockHelperMissing"), s = [this.contextName(0)];
        this.setupHelperArgs(t, 0, s);
        var o = this.popStack();
        s.splice(1, 0, o), this.push(this.source.functionCall(e, "call", s));
      },
      // [ambiguousBlockValue]
      //
      // On stack, before: hash, inverse, program, value
      // Compiler value, before: lastHelper=value of last found helper, if any
      // On stack, after, if no lastHelper: same as [blockValue]
      // On stack, after, if lastHelper: value
      ambiguousBlockValue: function() {
        var t = this.aliasable("container.hooks.blockHelperMissing"), e = [this.contextName(0)];
        this.setupHelperArgs("", 0, e, !0), this.flushInline();
        var s = this.topStack();
        e.splice(1, 0, s), this.pushSource(["if (!", this.lastHelper, ") { ", s, " = ", this.source.functionCall(t, "call", e), "}"]);
      },
      // [appendContent]
      //
      // On stack, before: ...
      // On stack, after: ...
      //
      // Appends the string value of `content` to the current buffer
      appendContent: function(t) {
        this.pendingContent ? t = this.pendingContent + t : this.pendingLocation = this.source.currentLocation, this.pendingContent = t;
      },
      // [append]
      //
      // On stack, before: value, ...
      // On stack, after: ...
      //
      // Coerces `value` to a String and appends it to the current buffer.
      //
      // If `value` is truthy, or 0, it is coerced into a string and appended
      // Otherwise, the empty string is appended
      append: function() {
        if (this.isInline())
          this.replaceStack(function(e) {
            return [" != null ? ", e, ' : ""'];
          }), this.pushSource(this.appendToBuffer(this.popStack()));
        else {
          var t = this.popStack();
          this.pushSource(["if (", t, " != null) { ", this.appendToBuffer(t, void 0, !0), " }"]), this.environment.isSimple && this.pushSource(["else { ", this.appendToBuffer("''", void 0, !0), " }"]);
        }
      },
      // [appendEscaped]
      //
      // On stack, before: value, ...
      // On stack, after: ...
      //
      // Escape `value` and append it to the buffer
      appendEscaped: function() {
        this.pushSource(this.appendToBuffer([this.aliasable("container.escapeExpression"), "(", this.popStack(), ")"]));
      },
      // [getContext]
      //
      // On stack, before: ...
      // On stack, after: ...
      // Compiler value, after: lastContext=depth
      //
      // Set the value of the `lastContext` compiler value to the depth
      getContext: function(t) {
        this.lastContext = t;
      },
      // [pushContext]
      //
      // On stack, before: ...
      // On stack, after: currentContext, ...
      //
      // Pushes the value of the current context onto the stack.
      pushContext: function() {
        this.pushStackLiteral(this.contextName(this.lastContext));
      },
      // [lookupOnContext]
      //
      // On stack, before: ...
      // On stack, after: currentContext[name], ...
      //
      // Looks up the value of `name` on the current context and pushes
      // it onto the stack.
      lookupOnContext: function(t, e, s, o) {
        var f = 0;
        !o && this.options.compat && !this.lastContext ? this.push(this.depthedLookup(t[f++])) : this.pushContext(), this.resolvePath("context", t, f, e, s);
      },
      // [lookupBlockParam]
      //
      // On stack, before: ...
      // On stack, after: blockParam[name], ...
      //
      // Looks up the value of `parts` on the given block param and pushes
      // it onto the stack.
      lookupBlockParam: function(t, e) {
        this.useBlockParams = !0, this.push(["blockParams[", t[0], "][", t[1], "]"]), this.resolvePath("context", e, 1);
      },
      // [lookupData]
      //
      // On stack, before: ...
      // On stack, after: data, ...
      //
      // Push the data lookup operator
      lookupData: function(t, e, s) {
        t ? this.pushStackLiteral("container.data(data, " + t + ")") : this.pushStackLiteral("data"), this.resolvePath("data", e, 0, !0, s);
      },
      resolvePath: function(t, e, s, o, f) {
        var v = this;
        if (this.options.strict || this.options.assumeObjects) {
          this.push(c(this.options.strict && f, this, e, s, t));
          return;
        }
        for (var C = e.length; s < C; s++)
          this.replaceStack(function(l) {
            var p = v.nameLookup(l, e[s], t);
            return o ? [" && ", p] : [" != null ? ", p, " : ", l];
          });
      },
      // [resolvePossibleLambda]
      //
      // On stack, before: value, ...
      // On stack, after: resolved value, ...
      //
      // If the `value` is a lambda, replace it on the stack by
      // the return value of the lambda
      resolvePossibleLambda: function() {
        this.push([this.aliasable("container.lambda"), "(", this.popStack(), ", ", this.contextName(0), ")"]);
      },
      // [pushStringParam]
      //
      // On stack, before: ...
      // On stack, after: string, currentContext, ...
      //
      // This opcode is designed for use in string mode, which
      // provides the string value of a parameter along with its
      // depth rather than resolving it immediately.
      pushStringParam: function(t, e) {
        this.pushContext(), this.pushString(e), e !== "SubExpression" && (typeof t == "string" ? this.pushString(t) : this.pushStackLiteral(t));
      },
      emptyHash: function(t) {
        this.trackIds && this.push("{}"), this.stringParams && (this.push("{}"), this.push("{}")), this.pushStackLiteral(t ? "undefined" : "{}");
      },
      pushHash: function() {
        this.hash && this.hashes.push(this.hash), this.hash = { values: {}, types: [], contexts: [], ids: [] };
      },
      popHash: function() {
        var t = this.hash;
        this.hash = this.hashes.pop(), this.trackIds && this.push(this.objectLiteral(t.ids)), this.stringParams && (this.push(this.objectLiteral(t.contexts)), this.push(this.objectLiteral(t.types))), this.push(this.objectLiteral(t.values));
      },
      // [pushString]
      //
      // On stack, before: ...
      // On stack, after: quotedString(string), ...
      //
      // Push a quoted version of `string` onto the stack
      pushString: function(t) {
        this.pushStackLiteral(this.quotedString(t));
      },
      // [pushLiteral]
      //
      // On stack, before: ...
      // On stack, after: value, ...
      //
      // Pushes a value onto the stack. This operation prevents
      // the compiler from creating a temporary variable to hold
      // it.
      pushLiteral: function(t) {
        this.pushStackLiteral(t);
      },
      // [pushProgram]
      //
      // On stack, before: ...
      // On stack, after: program(guid), ...
      //
      // Push a program expression onto the stack. This takes
      // a compile-time guid and converts it into a runtime-accessible
      // expression.
      pushProgram: function(t) {
        t != null ? this.pushStackLiteral(this.programExpression(t)) : this.pushStackLiteral(null);
      },
      // [registerDecorator]
      //
      // On stack, before: hash, program, params..., ...
      // On stack, after: ...
      //
      // Pops off the decorator's parameters, invokes the decorator,
      // and inserts the decorator into the decorators list.
      registerDecorator: function(t, e) {
        var s = this.nameLookup("decorators", e, "decorator"), o = this.setupHelperArgs(e, t);
        this.decorators.push(["fn = ", this.decorators.functionCall(s, "", ["fn", "props", "container", o]), " || fn;"]);
      },
      // [invokeHelper]
      //
      // On stack, before: hash, inverse, program, params..., ...
      // On stack, after: result of helper invocation
      //
      // Pops off the helper's parameters, invokes the helper,
      // and pushes the helper's return value onto the stack.
      //
      // If the helper is not found, `helperMissing` is called.
      invokeHelper: function(t, e, s) {
        var o = this.popStack(), f = this.setupHelper(t, e), v = [];
        s && v.push(f.name), v.push(o), this.options.strict || v.push(this.aliasable("container.hooks.helperMissing"));
        var C = ["(", this.itemsSeparatedBy(v, "||"), ")"], l = this.source.functionCall(C, "call", f.callParams);
        this.push(l);
      },
      itemsSeparatedBy: function(t, e) {
        var s = [];
        s.push(t[0]);
        for (var o = 1; o < t.length; o++)
          s.push(e, t[o]);
        return s;
      },
      // [invokeKnownHelper]
      //
      // On stack, before: hash, inverse, program, params..., ...
      // On stack, after: result of helper invocation
      //
      // This operation is used when the helper is known to exist,
      // so a `helperMissing` fallback is not required.
      invokeKnownHelper: function(t, e) {
        var s = this.setupHelper(t, e);
        this.push(this.source.functionCall(s.name, "call", s.callParams));
      },
      // [invokeAmbiguous]
      //
      // On stack, before: hash, inverse, program, params..., ...
      // On stack, after: result of disambiguation
      //
      // This operation is used when an expression like `{{foo}}`
      // is provided, but we don't know at compile-time whether it
      // is a helper or a path.
      //
      // This operation emits more code than the other options,
      // and can be avoided by passing the `knownHelpers` and
      // `knownHelpersOnly` flags at compile-time.
      invokeAmbiguous: function(t, e) {
        this.useRegister("helper");
        var s = this.popStack();
        this.emptyHash();
        var o = this.setupHelper(0, t, e), f = this.lastHelper = this.nameLookup("helpers", t, "helper"), v = ["(", "(helper = ", f, " || ", s, ")"];
        this.options.strict || (v[0] = "(helper = ", v.push(" != null ? helper : ", this.aliasable("container.hooks.helperMissing"))), this.push(["(", v, o.paramsInit ? ["),(", o.paramsInit] : [], "),", "(typeof helper === ", this.aliasable('"function"'), " ? ", this.source.functionCall("helper", "call", o.callParams), " : helper))"]);
      },
      // [invokePartial]
      //
      // On stack, before: context, ...
      // On stack after: result of partial invocation
      //
      // This operation pops off a context, invokes a partial with that context,
      // and pushes the result of the invocation back.
      invokePartial: function(t, e, s) {
        var o = [], f = this.setupParams(e, 1, o);
        t && (e = this.popStack(), delete f.name), s && (f.indent = JSON.stringify(s)), f.helpers = "helpers", f.partials = "partials", f.decorators = "container.decorators", t ? o.unshift(e) : o.unshift(this.nameLookup("partials", e, "partial")), this.options.compat && (f.depths = "depths"), f = this.objectLiteral(f), o.push(f), this.push(this.source.functionCall("container.invokePartial", "", o));
      },
      // [assignToHash]
      //
      // On stack, before: value, ..., hash, ...
      // On stack, after: ..., hash, ...
      //
      // Pops a value off the stack and assigns it to the current hash
      assignToHash: function(t) {
        var e = this.popStack(), s = void 0, o = void 0, f = void 0;
        this.trackIds && (f = this.popStack()), this.stringParams && (o = this.popStack(), s = this.popStack());
        var v = this.hash;
        s && (v.contexts[t] = s), o && (v.types[t] = o), f && (v.ids[t] = f), v.values[t] = e;
      },
      pushId: function(t, e, s) {
        t === "BlockParam" ? this.pushStackLiteral("blockParams[" + e[0] + "].path[" + e[1] + "]" + (s ? " + " + JSON.stringify("." + s) : "")) : t === "PathExpression" ? this.pushString(e) : t === "SubExpression" ? this.pushStackLiteral("true") : this.pushStackLiteral("null");
      },
      // HELPERS
      compiler: n,
      compileChildren: function(t, e) {
        for (var s = t.children, o = void 0, f = void 0, v = 0, C = s.length; v < C; v++) {
          o = s[v], f = new this.compiler();
          var l = this.matchExistingProgram(o);
          if (l == null) {
            this.context.programs.push("");
            var p = this.context.programs.length;
            o.index = p, o.name = "program" + p, this.context.programs[p] = f.compile(o, e, this.context, !this.precompile), this.context.decorators[p] = f.decorators, this.context.environments[p] = o, this.useDepths = this.useDepths || f.useDepths, this.useBlockParams = this.useBlockParams || f.useBlockParams, o.useDepths = this.useDepths, o.useBlockParams = this.useBlockParams;
          } else
            o.index = l.index, o.name = "program" + l.index, this.useDepths = this.useDepths || l.useDepths, this.useBlockParams = this.useBlockParams || l.useBlockParams;
        }
      },
      matchExistingProgram: function(t) {
        for (var e = 0, s = this.context.environments.length; e < s; e++) {
          var o = this.context.environments[e];
          if (o && o.equals(t))
            return o;
        }
      },
      programExpression: function(t) {
        var e = this.environment.children[t], s = [e.index, "data", e.blockParams];
        return (this.useBlockParams || this.useDepths) && s.push("blockParams"), this.useDepths && s.push("depths"), "container.program(" + s.join(", ") + ")";
      },
      useRegister: function(t) {
        this.registers[t] || (this.registers[t] = !0, this.registers.list.push(t));
      },
      push: function(t) {
        return t instanceof a || (t = this.source.wrap(t)), this.inlineStack.push(t), t;
      },
      pushStackLiteral: function(t) {
        this.push(new a(t));
      },
      pushSource: function(t) {
        this.pendingContent && (this.source.push(this.appendToBuffer(this.source.quotedString(this.pendingContent), this.pendingLocation)), this.pendingContent = void 0), t && this.source.push(t);
      },
      replaceStack: function(t) {
        var e = ["("], s = void 0, o = void 0, f = void 0;
        if (!this.isInline())
          throw new h.default("replaceStack on non-inline");
        var v = this.popStack(!0);
        if (v instanceof a)
          s = [v.value], e = ["(", s], f = !0;
        else {
          o = !0;
          var C = this.incrStack();
          e = ["((", this.push(C), " = ", v, ")"], s = this.topStack();
        }
        var l = t.call(this, s);
        f || this.popStack(), o && this.stackSlot--, this.push(e.concat(l, ")"));
      },
      incrStack: function() {
        return this.stackSlot++, this.stackSlot > this.stackVars.length && this.stackVars.push("stack" + this.stackSlot), this.topStackName();
      },
      topStackName: function() {
        return "stack" + this.stackSlot;
      },
      flushInline: function() {
        var t = this.inlineStack;
        this.inlineStack = [];
        for (var e = 0, s = t.length; e < s; e++) {
          var o = t[e];
          if (o instanceof a)
            this.compileStack.push(o);
          else {
            var f = this.incrStack();
            this.pushSource([f, " = ", o, ";"]), this.compileStack.push(f);
          }
        }
      },
      isInline: function() {
        return this.inlineStack.length;
      },
      popStack: function(t) {
        var e = this.isInline(), s = (e ? this.inlineStack : this.compileStack).pop();
        if (!t && s instanceof a)
          return s.value;
        if (!e) {
          if (!this.stackSlot)
            throw new h.default("Invalid stack pop");
          this.stackSlot--;
        }
        return s;
      },
      topStack: function() {
        var t = this.isInline() ? this.inlineStack : this.compileStack, e = t[t.length - 1];
        return e instanceof a ? e.value : e;
      },
      contextName: function(t) {
        return this.useDepths && t ? "depths[" + t + "]" : "depth" + t;
      },
      quotedString: function(t) {
        return this.source.quotedString(t);
      },
      objectLiteral: function(t) {
        return this.source.objectLiteral(t);
      },
      aliasable: function(t) {
        var e = this.aliases[t];
        return e ? (e.referenceCount++, e) : (e = this.aliases[t] = this.source.wrap(t), e.aliasable = !0, e.referenceCount = 1, e);
      },
      setupHelper: function(t, e, s) {
        var o = [], f = this.setupHelperArgs(e, t, o, s), v = this.nameLookup("helpers", e, "helper"), C = this.aliasable(this.contextName(0) + " != null ? " + this.contextName(0) + " : (container.nullContext || {})");
        return {
          params: o,
          paramsInit: f,
          name: v,
          callParams: [C].concat(o)
        };
      },
      setupParams: function(t, e, s) {
        var o = {}, f = [], v = [], C = [], l = !s, p = void 0;
        l && (s = []), o.name = this.quotedString(t), o.hash = this.popStack(), this.trackIds && (o.hashIds = this.popStack()), this.stringParams && (o.hashTypes = this.popStack(), o.hashContexts = this.popStack());
        var _ = this.popStack(), L = this.popStack();
        (L || _) && (o.fn = L || "container.noop", o.inverse = _ || "container.noop");
        for (var E = e; E--; )
          p = this.popStack(), s[E] = p, this.trackIds && (C[E] = this.popStack()), this.stringParams && (v[E] = this.popStack(), f[E] = this.popStack());
        return l && (o.args = this.source.generateArray(s)), this.trackIds && (o.ids = this.source.generateArray(C)), this.stringParams && (o.types = this.source.generateArray(v), o.contexts = this.source.generateArray(f)), this.options.data && (o.data = "data"), this.useBlockParams && (o.blockParams = "blockParams"), o;
      },
      setupHelperArgs: function(t, e, s, o) {
        var f = this.setupParams(t, e, s);
        return f.loc = JSON.stringify(this.source.currentLocation), f = this.objectLiteral(f), o ? (this.useRegister("options"), s.push("options"), ["options=", f]) : s ? (s.push(f), "") : f;
      }
    }, (function() {
      for (var r = "break else new var case finally return void catch for switch while continue function this with default if throw delete in try do instanceof typeof abstract enum int short boolean export interface static byte extends long super char final native synchronized class float package throws const goto private transient debugger implements protected volatile double import public let yield await null true false".split(" "), t = n.RESERVED_WORDS = {}, e = 0, s = r.length; e < s; e++)
        t[r[e]] = !0;
    })(), n.isValidJavaScriptVariableName = function(r) {
      return !n.RESERVED_WORDS[r] && /^[a-zA-Z_$][0-9a-zA-Z_$]*$/.test(r);
    };
    function c(r, t, e, s, o) {
      var f = t.popStack(), v = e.length;
      for (r && v--; s < v; s++)
        f = t.nameLookup(f, e[s], o);
      return r ? [t.aliasable("container.strict"), "(", f, ", ", t.quotedString(e[s]), ", ", JSON.stringify(t.source.currentLocation), " )"] : f;
    }
    m.default = n, g.exports = m.default;
  })(Oe, Oe.exports)), Oe.exports;
}
var qt;
function Fr() {
  return qt || (qt = 1, (function(g, m) {
    m.__esModule = !0;
    function b(v) {
      return v && v.__esModule ? v : { default: v };
    }
    var y = Mr(), k = b(y), h = Ut(), d = b(h), u = Or(), i = Ar(), a = Vr(), n = b(a), c = Wt(), r = b(c), t = Gt(), e = b(t), s = k.default.create;
    function o() {
      var v = s();
      return v.compile = function(C, l) {
        return i.compile(C, l, v);
      }, v.precompile = function(C, l) {
        return i.precompile(C, l, v);
      }, v.AST = d.default, v.Compiler = i.Compiler, v.JavaScriptCompiler = n.default, v.Parser = u.parser, v.parse = u.parse, v.parseWithoutProcessing = u.parseWithoutProcessing, v;
    }
    var f = o();
    f.create = o, e.default(f), f.Visitor = r.default, f.default = f, m.default = f, g.exports = m.default;
  })(ue, ue.exports)), ue.exports;
}
var Gr = Fr();
const Ur = /* @__PURE__ */ sr(Gr), Wr = ["innerHTML"], zr = {
  __name: "SlotWorkaround",
  props: {
    element: {
      type: Element,
      default: null
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  setup(g) {
    const m = g, b = j(() => {
      const k = m.element.outerHTML;
      return Ur.compile(k);
    }), y = j(() => b.value(m.data));
    return (k, h) => (w(), O("div", { innerHTML: y.value }, null, 8, Wr));
  }
}, Kr = {
  class: "offset-product-list",
  ref: "container"
}, Qr = { key: 1 }, Jr = ["href"], Yr = ["src", "alt"], jr = ["onClick"], Xr = ["src", "alt"], Zr = {
  key: 2,
  class: "badge badge-secondary product-badge"
}, $r = { class: "offset-product-title" }, en = ["innerHTML"], tn = { key: 0 }, rn = ["innerHTML"], nn = ["href"], sn = ["onClick"], an = { class: "offset-options" }, on = { class: "offset-price" }, ln = { class: "offset-variants" }, un = { class: "offset-buy" }, cn = ["href"], hn = ["src", "alt"], pn = { class: "offset-product-title" }, fn = ["innerHTML"], dn = { key: 0 }, vn = {
  key: 1,
  class: "offset-product-specs"
}, gn = { key: 0 }, mn = { key: 1 }, _n = { key: 2 }, yn = { class: "offset-options" }, Sn = { class: "offset-price" }, kn = { class: "offset-variants" }, bn = { class: "offset-buy" }, Cn = { class: "offset-product-modal-body" }, Ln = { class: "offset-product-modal-images" }, Pn = ["src", "alt", "loading"], Mn = { class: "offset-product-modal-details" }, En = { class: "offset-product-modal-title" }, xn = ["innerHTML"], wn = { key: 0 }, On = ["innerHTML"], An = { class: "offset-product-modal-specs" }, Rn = { key: 0 }, Nn = ["innerHTML"], In = { key: 1 }, Hn = ["innerHTML"], Tn = { key: 2 }, Dn = ["innerHTML"], qn = { key: 3 }, Bn = ["innerHTML"], Vn = { key: 4 }, Fn = ["innerHTML"], Gn = { key: 5 }, Un = ["innerHTML"], Wn = { key: 6 }, zn = ["innerHTML"], Kn = { key: 7 }, Qn = ["innerHTML"], Jn = { key: 8 }, Yn = ["innerHTML"], jn = { key: 9 }, Xn = ["innerHTML"], Zn = { key: 10 }, $n = ["innerHTML"], ei = { key: 11 }, ti = ["innerHTML"], ri = { key: 12 }, ni = ["innerHTML"], ii = { key: 13 }, si = ["innerHTML"], ai = { key: 14 }, oi = ["innerHTML"], li = { key: 15 }, ui = ["innerHTML"], ci = { key: 16 }, hi = ["innerHTML"], pi = { key: 17 }, fi = ["innerHTML"], di = { key: 18 }, vi = ["innerHTML"], gi = { key: 19 }, mi = ["innerHTML"], _i = { key: 20 }, yi = ["innerHTML"], Si = { key: 21 }, ki = ["innerHTML"], bi = { key: 22 }, Ci = ["innerHTML"], Li = { key: 23 }, Pi = ["innerHTML"], Mi = { key: 24 }, Ei = ["innerHTML"], xi = { key: 25 }, wi = ["innerHTML"], Oi = { key: 26 }, Ai = ["innerHTML"], Ri = { class: "offset-product-modal-purchase" }, Ni = { class: "offset-options" }, Ii = { class: "offset-price" }, Hi = { class: "offset-variants" }, Ti = { class: "offset-buy" }, Di = {
  __name: "ProductList",
  props: {
    inheritStyle: {
      type: String,
      default: "all"
    },
    collectionSlug: {
      type: String,
      // TODO: Look up the config['shop_category'] for the default value
      required: !0
    },
    displayedAs: {
      type: String,
      default: ""
    },
    // See ../lib/product-filter.ts for the syntax this accepts, e.g.
    // filter="vintage:2020|2021,price:>=100". Applied on top of whatever
    // useProduct() already returns for this collectionSlug — deliberately
    // NOT folded into that shared, cross-instance computed, since `filter`
    // is specific to this one <offset-product-list> element (two instances
    // with the same collection-slug but different filter values must not
    // affect each other).
    filter: {
      type: String,
      default: ""
    },
    slots: {
      type: Object,
      default: () => ({})
    }
  },
  setup(g) {
    const m = g, { isPending: b, productsSortedAndFiltered: y } = $t(
      m.collectionSlug
    ), k = j(() => pr(y.value, m.filter)), { addToCart: h } = er(), d = je("container"), u = je("dialog"), i = te(null), a = te(1), n = te(""), c = j(() => k.value.map((p) => {
      var E;
      const _ = Y(p.bottle_size) ? "750ml" : p.bottle_size, L = {
        [p.sku]: {
          name: p.name,
          bottle_size: _,
          price: p.price,
          max_purchase_quantity: p.max_purchase_quantity
        }
      };
      return (E = p.variants) == null || E.forEach((A) => {
        L[A.sku] = {
          name: A.name,
          bottle_size: A.bottle_size,
          price: A.price,
          // Each variant/bottle-size can have its own real limit (already
          // resolved against its own purchase_limit by use-product.ts) —
          // without this, addToCart() always fell back to the top-level
          // product's own max_purchase_quantity regardless of which
          // variant was actually selected/added.
          max_purchase_quantity: A.max_purchase_quantity
        };
      }), Ye(Je({}, p), {
        variants: L,
        selectedVariant: te(p.sku),
        quantitySelected: te(1)
      });
    }));
    function r(p) {
      return Math.round(parseFloat(p) * 100) % 100 === 0;
    }
    const t = j(() => c.value.every(
      (p) => Object.values(p.variants).every((_) => r(_.price))
    )), e = j(() => {
      if (!i.value) return [];
      const p = i.value, _ = [];
      return p.image && _.push(p.image), Y(p.image_alt) || _.push(p.image_alt_medium || p.image_alt), Y(p.image_alt_3) || _.push(p.image_alt_3_medium || p.image_alt_3), _;
    });
    function s(p, _) {
      p.quantitySelected.value = _;
    }
    function o(p) {
      var _;
      i.value = p, a.value = 1, n.value = p.sku, (_ = u.value) == null || _.showModal();
    }
    const f = j(() => {
      var p;
      return (p = window.OFFSET) == null ? void 0 : p.productDetailsUrl;
    });
    function v(p) {
      const _ = Y(p.seo_slug) ? p.sku : p.seo_slug, [L, E] = f.value.split("?"), A = `${L.replace(/\/+$/, "")}/${_}`;
      return E ? `${A}?${E}` : A;
    }
    function C() {
      var p;
      (p = u.value) == null || p.close(), i.value = null;
    }
    function l(p) {
      p.target === u.value && C();
    }
    return tr(() => {
      rr(d.value, m.inheritStyle);
    }), (p, _) => {
      var L, E, A, x;
      return w(), O("div", Kr, [
        U(b) ? (w(), re(nr, {
          key: 0,
          count: 4
        }, {
          default: K(() => _[4] || (_[4] = [
            Q("Loading...", -1)
          ])),
          _: 1,
          __: [4]
        })) : c.value.length ? (w(), O("div", {
          key: 2,
          class: le(["offset-products", { "offset-products--modal": g.displayedAs === "details-in-modal" }])
        }, [
          (w(!0), O(z, null, ne(c.value, (S) => (w(), O("div", {
            key: S.sku,
            class: "offset-product"
          }, [
            m.slots.product ? (w(), re(zr, {
              key: 0,
              element: m.slots.product,
              data: S
            }, null, 8, ["element", "data"])) : g.displayedAs === "details-in-modal" ? (w(), O(z, { key: 1 }, [
              !U(Y)(S.image) && f.value ? (w(), O("a", {
                key: 0,
                href: v(S),
                class: "offset-product-image-link"
              }, [
                M("figure", null, [
                  M("img", {
                    src: S.image_medium || S.image || S.image_generic_product,
                    alt: S.variants[S.selectedVariant.value].name + " " + S.variants[S.selectedVariant.value].subtitle,
                    loading: "lazy",
                    decoding: "async"
                  }, null, 8, Yr)
                ])
              ], 8, Jr)) : U(Y)(S.image) ? N("", !0) : (w(), O("button", {
                key: 1,
                type: "button",
                class: "offset-product-image-link",
                onClick: (P) => o(S)
              }, [
                M("figure", null, [
                  M("img", {
                    src: S.image_medium || S.image || S.image_generic_product,
                    alt: S.variants[S.selectedVariant.value].name + " " + S.variants[S.selectedVariant.value].subtitle,
                    loading: "lazy",
                    decoding: "async"
                  }, null, 8, Xr)
                ])
              ], 8, jr)),
              S.product_badge ? (w(), O("span", Zr, B(S.product_badge), 1)) : N("", !0),
              M("h3", $r, [
                M("span", {
                  innerHTML: S.variants[S.selectedVariant.value].name
                }, null, 8, en),
                S.subtitle ? (w(), O("small", tn, B(S.subtitle), 1)) : N("", !0)
              ]),
              S.short_description ? (w(), O("p", {
                key: 3,
                class: "offset-product-short-description",
                innerHTML: S.short_description
              }, null, 8, rn)) : N("", !0),
              S.additional_description && f.value ? (w(), O("a", {
                key: 4,
                href: v(S),
                class: "offset-product-details-btn"
              }, " DETAILS + ", 8, nn)) : S.additional_description ? (w(), O("button", {
                key: 5,
                class: "offset-product-details-btn",
                onClick: (P) => o(S)
              }, " DETAILS + ", 8, sn)) : N("", !0),
              M("div", an, [
                M("div", on, B(U(De)(S.variants[S.selectedVariant.value].price, t.value)), 1),
                M("div", ln, [
                  (w(!0), O(z, null, ne(S.variants, (P, R) => (w(), re(Ie(Object.keys(S.variants).length > 1 ? "button" : "span"), {
                    key: R,
                    type: Object.keys(S.variants).length > 1 ? "button" : void 0,
                    "aria-pressed": Object.keys(S.variants).length > 1 ? S.selectedVariant.value === R : void 0,
                    onClick: (I) => Object.keys(S.variants).length > 1 && (S.selectedVariant.value = R),
                    class: le({ active: S.selectedVariant.value === R })
                  }, {
                    default: K(() => [
                      Q(B(P.bottle_size), 1)
                    ]),
                    _: 2
                  }, 1032, ["type", "aria-pressed", "onClick", "class"]))), 128))
                ])
              ]),
              M("div", un, [
                J(Te, {
                  onChange: (P) => s(S, P),
                  modelValue: S.quantitySelected.value,
                  "onUpdate:modelValue": (P) => S.quantitySelected.value = P,
                  max: S.variants[S.selectedVariant.value].max_purchase_quantity,
                  min: 1
                }, null, 8, ["onChange", "modelValue", "onUpdate:modelValue", "max"]),
                J(He, {
                  "aria-label": `Add ${S.variants[S.selectedVariant.value].name} to cart`,
                  onClick: (P) => U(h)(S.selectedVariant.value, S.quantitySelected.value, {
                    maxPurchaseQuantity: S.variants[S.selectedVariant.value].max_purchase_quantity
                  })
                }, {
                  default: K(() => _[5] || (_[5] = [
                    Q(" ADD ", -1)
                  ])),
                  _: 2,
                  __: [5]
                }, 1032, ["aria-label", "onClick"])
              ])
            ], 64)) : (w(), O(z, { key: 2 }, [
              U(Y)(S.image) ? N("", !0) : (w(), O("a", {
                key: 0,
                href: "/product/detail/" + S.sku
              }, [
                M("figure", null, [
                  M("img", {
                    src: S.image_medium || S.image,
                    alt: S.variants[S.selectedVariant.value].name,
                    loading: "lazy",
                    decoding: "async"
                  }, null, 8, hn)
                ])
              ], 8, cn)),
              M("h3", pn, [
                M("span", {
                  innerHTML: S.variants[S.selectedVariant.value].name
                }, null, 8, fn),
                S.subtitle ? (w(), O("small", dn, B(S.subtitle), 1)) : N("", !0)
              ]),
              S.varietal || S.region || S.sub_region ? (w(), O("p", vn, [
                S.varietal ? (w(), O("span", gn, B(S.varietal), 1)) : N("", !0),
                S.region ? (w(), O("span", mn, " | " + B(S.region), 1)) : N("", !0),
                S.sub_region ? (w(), O("span", _n, " | " + B(S.sub_region), 1)) : N("", !0)
              ])) : N("", !0),
              M("div", yn, [
                M("div", Sn, B(U(De)(
                  S.variants[S.selectedVariant.value].price,
                  t.value
                )), 1),
                M("div", kn, [
                  (w(!0), O(z, null, ne(S.variants, (P, R) => (w(), re(Ie(Object.keys(S.variants).length > 1 ? "button" : "span"), {
                    key: R,
                    type: Object.keys(S.variants).length > 1 ? "button" : void 0,
                    "aria-pressed": Object.keys(S.variants).length > 1 ? S.selectedVariant.value === R : void 0,
                    onClick: (I) => Object.keys(S.variants).length > 1 && (S.selectedVariant.value = R),
                    class: le([S.selectedVariant.value === R ? "active" : ""])
                  }, {
                    default: K(() => [
                      Q(B(P.bottle_size), 1)
                    ]),
                    _: 2
                  }, 1032, ["type", "aria-pressed", "onClick", "class"]))), 128))
                ])
              ]),
              M("div", bn, [
                J(Te, {
                  onChange: (P) => s(S, P),
                  modelValue: S.quantitySelected.value,
                  "onUpdate:modelValue": (P) => S.quantitySelected.value = P,
                  max: S.variants[S.selectedVariant.value].max_purchase_quantity,
                  min: 1
                }, null, 8, ["onChange", "modelValue", "onUpdate:modelValue", "max"]),
                J(He, {
                  "aria-label": `Add ${S.variants[S.selectedVariant.value].name} to cart`,
                  onClick: (P) => U(h)(
                    S.selectedVariant.value,
                    S.quantitySelected.value,
                    { maxPurchaseQuantity: S.variants[S.selectedVariant.value].max_purchase_quantity }
                  )
                }, {
                  default: K(() => _[6] || (_[6] = [
                    Q(" ADD ", -1)
                  ])),
                  _: 2,
                  __: [6]
                }, 1032, ["aria-label", "onClick"])
              ])
            ], 64))
          ]))), 128))
        ], 2)) : (w(), O("div", Qr, "No products found")),
        M("dialog", {
          ref: "dialog",
          class: "offset-product-modal",
          onClose: _[3] || (_[3] = (S) => i.value = null),
          onClick: l
        }, [
          i.value ? (w(), O(z, { key: 0 }, [
            M("button", {
              class: "offset-product-modal-close",
              onClick: C,
              "aria-label": "Close"
            }, "✕"),
            M("div", Cn, [
              M("div", Ln, [
                (w(!0), O(z, null, ne(e.value, (S, P) => {
                  var R;
                  return w(), O("figure", {
                    key: P,
                    class: "offset-product-modal-image"
                  }, [
                    M("img", {
                      src: S,
                      alt: (((R = i.value.variants[n.value]) == null ? void 0 : R.name) || "") + " " + (i.value.subtitle || ""),
                      loading: P === 0 ? "eager" : "lazy",
                      decoding: "async"
                    }, null, 8, Pn)
                  ]);
                }), 128))
              ]),
              M("div", Mn, [
                M("h2", En, [
                  M("span", {
                    innerHTML: i.value.label || ((L = i.value.variants[n.value]) == null ? void 0 : L.name)
                  }, null, 8, xn),
                  i.value.subtitle ? (w(), O("small", wn, B(i.value.subtitle), 1)) : N("", !0)
                ]),
                i.value.additional_description ? (w(), O("div", {
                  key: 0,
                  class: "offset-product-modal-description",
                  innerHTML: i.value.additional_description
                }, null, 8, On)) : N("", !0),
                M("ul", An, [
                  i.value.varietal ? (w(), O("li", Rn, [
                    _[7] || (_[7] = M("span", { class: "spec-title" }, "Varietal", -1)),
                    M("span", {
                      class: "spec-value",
                      innerHTML: i.value.varietal
                    }, null, 8, Nn)
                  ])) : N("", !0),
                  i.value.vintage ? (w(), O("li", In, [
                    _[8] || (_[8] = M("span", { class: "spec-title" }, "Vintage", -1)),
                    M("span", {
                      class: "spec-value",
                      innerHTML: i.value.vintage
                    }, null, 8, Hn)
                  ])) : N("", !0),
                  i.value.winemaker ? (w(), O("li", Tn, [
                    _[9] || (_[9] = M("span", { class: "spec-title" }, "Winemaker", -1)),
                    M("span", {
                      class: "spec-value",
                      innerHTML: i.value.winemaker
                    }, null, 8, Dn)
                  ])) : N("", !0),
                  i.value.vineyard ? (w(), O("li", qn, [
                    _[10] || (_[10] = M("span", { class: "spec-title" }, "Vineyard", -1)),
                    M("span", {
                      class: "spec-value",
                      innerHTML: i.value.vineyard
                    }, null, 8, Bn)
                  ])) : N("", !0),
                  i.value.harvest_date ? (w(), O("li", Vn, [
                    _[11] || (_[11] = M("span", { class: "spec-title" }, "Harvest Date", -1)),
                    M("span", {
                      class: "spec-value",
                      innerHTML: i.value.harvest_date
                    }, null, 8, Fn)
                  ])) : N("", !0),
                  i.value.appellation ? (w(), O("li", Gn, [
                    _[12] || (_[12] = M("span", { class: "spec-title" }, "Appellation", -1)),
                    M("span", {
                      class: "spec-value",
                      innerHTML: i.value.appellation
                    }, null, 8, Un)
                  ])) : N("", !0),
                  i.value.region ? (w(), O("li", Wn, [
                    _[13] || (_[13] = M("span", { class: "spec-title" }, "Region", -1)),
                    M("span", {
                      class: "spec-value",
                      innerHTML: i.value.region
                    }, null, 8, zn)
                  ])) : N("", !0),
                  i.value.sub_region ? (w(), O("li", Kn, [
                    _[14] || (_[14] = M("span", { class: "spec-title" }, "Sub-Region", -1)),
                    M("span", {
                      class: "spec-value",
                      innerHTML: i.value.sub_region
                    }, null, 8, Qn)
                  ])) : N("", !0),
                  i.value.clones ? (w(), O("li", Jn, [
                    _[15] || (_[15] = M("span", { class: "spec-title" }, "Clones", -1)),
                    M("span", {
                      class: "spec-value",
                      innerHTML: i.value.clones
                    }, null, 8, Yn)
                  ])) : N("", !0),
                  i.value.vine_age ? (w(), O("li", jn, [
                    _[16] || (_[16] = M("span", { class: "spec-title" }, "Age of Vines at Harvest", -1)),
                    M("span", {
                      class: "spec-value",
                      innerHTML: i.value.vine_age
                    }, null, 8, Xn)
                  ])) : N("", !0),
                  i.value.soil ? (w(), O("li", Zn, [
                    _[17] || (_[17] = M("span", { class: "spec-title" }, "Soil", -1)),
                    M("span", {
                      class: "spec-value",
                      innerHTML: i.value.soil
                    }, null, 8, $n)
                  ])) : N("", !0),
                  i.value.farming_method ? (w(), O("li", ei, [
                    _[18] || (_[18] = M("span", { class: "spec-title" }, "Farming Method", -1)),
                    M("span", {
                      class: "spec-value",
                      innerHTML: i.value.farming_method
                    }, null, 8, ti)
                  ])) : N("", !0),
                  i.value.blend ? (w(), O("li", ri, [
                    _[19] || (_[19] = M("span", { class: "spec-title" }, "Blend", -1)),
                    M("span", {
                      class: "spec-value",
                      innerHTML: i.value.blend
                    }, null, 8, ni)
                  ])) : N("", !0),
                  i.value.oak ? (w(), O("li", ii, [
                    _[20] || (_[20] = M("span", { class: "spec-title" }, "Oak", -1)),
                    M("span", {
                      class: "spec-value",
                      innerHTML: i.value.oak
                    }, null, 8, si)
                  ])) : N("", !0),
                  i.value.aging ? (w(), O("li", ai, [
                    _[21] || (_[21] = M("span", { class: "spec-title" }, "Barrel Aging", -1)),
                    M("span", {
                      class: "spec-value",
                      innerHTML: i.value.aging
                    }, null, 8, oi)
                  ])) : N("", !0),
                  i.value.stainless ? (w(), O("li", li, [
                    _[22] || (_[22] = M("span", { class: "spec-title" }, "Stainless", -1)),
                    M("span", {
                      class: "spec-value",
                      innerHTML: i.value.stainless
                    }, null, 8, ui)
                  ])) : N("", !0),
                  i.value.residual_sugar ? (w(), O("li", ci, [
                    _[23] || (_[23] = M("span", { class: "spec-title" }, "Residual Sugar", -1)),
                    M("span", {
                      class: "spec-value",
                      innerHTML: i.value.residual_sugar
                    }, null, 8, hi)
                  ])) : N("", !0),
                  i.value.brix_at_harvest ? (w(), O("li", pi, [
                    _[24] || (_[24] = M("span", { class: "spec-title" }, "Brix at Harvest", -1)),
                    M("span", {
                      class: "spec-value",
                      innerHTML: i.value.brix_at_harvest
                    }, null, 8, fi)
                  ])) : N("", !0),
                  i.value.alcohol ? (w(), O("li", di, [
                    _[25] || (_[25] = M("span", { class: "spec-title" }, "Alcohol", -1)),
                    M("span", {
                      class: "spec-value",
                      innerHTML: i.value.alcohol + "%"
                    }, null, 8, vi)
                  ])) : N("", !0),
                  i.value.ph ? (w(), O("li", gi, [
                    _[26] || (_[26] = M("span", { class: "spec-title" }, "PH", -1)),
                    M("span", {
                      class: "spec-value",
                      innerHTML: i.value.ph
                    }, null, 8, mi)
                  ])) : N("", !0),
                  i.value.ta ? (w(), O("li", _i, [
                    _[27] || (_[27] = M("span", { class: "spec-title" }, "TA", -1)),
                    M("span", {
                      class: "spec-value",
                      innerHTML: i.value.ta + "g/100mLs"
                    }, null, 8, yi)
                  ])) : N("", !0),
                  i.value.case_production ? (w(), O("li", Si, [
                    _[28] || (_[28] = M("span", { class: "spec-title" }, "Production", -1)),
                    M("span", {
                      class: "spec-value",
                      innerHTML: i.value.case_production
                    }, null, 8, ki)
                  ])) : N("", !0),
                  i.value.production && !i.value.case_production ? (w(), O("li", bi, [
                    _[29] || (_[29] = M("span", { class: "spec-title" }, "Production", -1)),
                    M("span", {
                      class: "spec-value",
                      innerHTML: i.value.production
                    }, null, 8, Ci)
                  ])) : N("", !0),
                  i.value.release_date ? (w(), O("li", Li, [
                    _[30] || (_[30] = M("span", { class: "spec-title" }, "Release Date", -1)),
                    M("span", {
                      class: "spec-value",
                      innerHTML: i.value.release_date
                    }, null, 8, Pi)
                  ])) : N("", !0),
                  i.value.upc ? (w(), O("li", Mi, [
                    _[31] || (_[31] = M("span", { class: "spec-title" }, "UPC", -1)),
                    M("span", {
                      class: "spec-value",
                      innerHTML: i.value.upc
                    }, null, 8, Ei)
                  ])) : N("", !0),
                  i.value.press ? (w(), O("li", xi, [
                    _[32] || (_[32] = M("span", { class: "spec-title" }, "Press", -1)),
                    M("span", {
                      class: "spec-value",
                      innerHTML: i.value.press
                    }, null, 8, wi)
                  ])) : N("", !0),
                  i.value.score ? (w(), O("li", Oi, [
                    _[33] || (_[33] = M("span", { class: "spec-title" }, "Score", -1)),
                    M("span", {
                      class: "spec-value",
                      innerHTML: i.value.score
                    }, null, 8, Ai)
                  ])) : N("", !0)
                ]),
                M("div", Ri, [
                  M("div", Ni, [
                    M("div", Ii, B(U(De)((E = i.value.variants[n.value]) == null ? void 0 : E.price, t.value)), 1),
                    M("div", Hi, [
                      (w(!0), O(z, null, ne(i.value.variants, (S, P) => (w(), re(Ie(Object.keys(i.value.variants).length > 1 ? "button" : "span"), {
                        key: P,
                        type: Object.keys(i.value.variants).length > 1 ? "button" : void 0,
                        "aria-pressed": Object.keys(i.value.variants).length > 1 ? n.value === P : void 0,
                        onClick: (R) => Object.keys(i.value.variants).length > 1 && (n.value = P),
                        class: le({ active: n.value === P })
                      }, {
                        default: K(() => [
                          Q(B(S.bottle_size), 1)
                        ]),
                        _: 2
                      }, 1032, ["type", "aria-pressed", "onClick", "class"]))), 128))
                    ])
                  ]),
                  M("div", Ti, [
                    J(Te, {
                      modelValue: a.value,
                      "onUpdate:modelValue": _[0] || (_[0] = (S) => a.value = S),
                      onChange: _[1] || (_[1] = (S) => a.value = S),
                      max: (A = i.value.variants[n.value]) == null ? void 0 : A.max_purchase_quantity,
                      min: 1
                    }, null, 8, ["modelValue", "max"]),
                    J(He, {
                      "aria-label": `Add ${(x = i.value.variants[n.value]) == null ? void 0 : x.name} to cart`,
                      onClick: _[2] || (_[2] = (S) => {
                        var P;
                        U(h)(n.value, a.value, {
                          maxPurchaseQuantity: (P = i.value.variants[n.value]) == null ? void 0 : P.max_purchase_quantity
                        }), C();
                      })
                    }, {
                      default: K(() => _[34] || (_[34] = [
                        Q(" ADD ", -1)
                      ])),
                      _: 1,
                      __: [34]
                    }, 8, ["aria-label"])
                  ]),
                  J(ir, { class: "offset-product-modal-prop65" })
                ])
              ])
            ])
          ], 64)) : N("", !0)
        ], 544)
      ], 512);
    };
  }
}, ji = /* @__PURE__ */ ar(Di, [["__scopeId", "data-v-83a3755e"]]);
export {
  ji as P
};
